// import React, { useState } from 'react'
// import { useEffect } from 'react';
// import ReactDatePicker from "react-datepicker";
// import { Button } from "../../common/Button/Button";
// import api from "../../utils/api";
// // import EngagedAnnualTurnover from './EngagedAnnualTurnover'
// // import EngagedPartner from './EngagedPartner'
// // import EUGrid from './EUGrid'
// // import EUSourceAndMedimGrid from './EUSourceAndMedimGrid'
// // import FirstTimeAnnualTurnover from './FirstTimeAnnualTurnover'
// // import FirstTimePartner from './FirstTimePartner'
// // import FTUGrid from './FTUGrid'
// // import FTUSourceAndMediumGrid from './FTUSourceAndMediumGrid'
// // import MonthlyDataGrid from './MonthlyDataGrid'
// // import MonthlyUserChart from './MonthlyUserChart'
// // import TotalEngagedUserChart from './TotalEngagedUserChart'
// // import TotalFirstTimeChart from './TotalFirstTimeChart'
// // import TotalResourceAwailed from './TotalResourceAwailed'
// import { toast } from 'react-toastify';
// import Modal from "react-modal";
// import ModalContent from '../../common/Modal/ModalContent';
// import close_modal from '../../assets/ic_close_wh.svg'
// import ic_filter from '../../assets/ic_filter.svg'
// // import FirstTimeProgram from './FirstTimeProgram';
// // import EngagedUserProgram from './EngagedUserProgram';
// // import DynamicProgramTable from './DynamicProgramTable';
// import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
// // import PartnerDataTable from './PartnerDataTable';
// import Spinner from '../../common/Spinner/Spinner';
// // import MergedPartnerTable from './MergedPartnerTable';
// // import MergedProgramTable from './MergedProgramTable';
// // import MergedResourceTable from './MergedResourceTable';
// // import MergedTurnoverTable from './MergedTurnoverTable';
// // import MergedPartnerResourceTable from './MergedPartnerResourceTable';
// // import MergedSourceMediumTable from './MergedSourceMediumTable';
// // import MergedProgramResourceTable from './MergedProgramResourceTable';
// // import ProgramManagerHome from './ProgramManagerHome';

// import DreamBigMergedPartnerResourceTable from './DreamBigMergedPartnerResourceTable';
// import DreamBigMergedTurnoverTable from './DreamBigMergedTurnoverTable';

// const DreamBigNewAndEngagedUserHome = () => {

//     const [countData, setCountData] = useState({
//         engaged_users: 0,
//         first_time_users: 0
//     })
//     const [resourceCount, setResourceCount] = useState({
//         record_engaged_users: 0,
//         first_time_users: 0,
//         total: 0
//     })


//     const FirstTimeAdditionalCount = 108840
//     const EngagedUserAdditionalCount = 55586

//     const TotalFirstTimeUserCount = countData.first_time_users + FirstTimeAdditionalCount;
//     const TotalEngagedUserCount = countData.engaged_users + EngagedUserAdditionalCount
//     const TotalResourceAvailedCount = resourceCount.total + FirstTimeAdditionalCount + EngagedUserAdditionalCount
//     const currentDateRangeResourceAvailedCount = resourceCount.total;


//     const [fromDate, setfromDate] = useState();
//     const [toDate, settoDate] = useState();
//     const [ftuGridData, setFtuGridData] = useState([])
//     const [euGridData, setEuGridData] = useState([])
//     const [firstTimePartnerData, setFirstTimePartnerData] = useState([])
//     const [engagedPartnerData, setEngagedPartner] = useState([])
//     const [firstTimeAnnualTurnoverData, setFirstTimeAnnualTurnoverData] = useState([])
//     const [engagedAnnualTurnoverData, setEngagedAnnualTurnoverData] = useState([])
//     const [ftuSourceAndMediumData, setFtuSourceAndMediumData] = useState([])
//     const [engagedSourceAndMediumData, setEngagedSourceAndMediumData] = useState([])
//     const [monthwiseData, setMonthwiseData] = useState([])
//     const [firstTimePartnerResourceData, setFirstTimePartnerResourceData] = useState([])
//     const [engagedPartnerResourceData, setEngagedPartnerResourceData] = useState([])
//     const [firstTimeProgramResourceData, setFirstTimeProgramResourceData] = useState([])
//     const [engagedProgramResourceData, setEngagedProgramResourceData] = useState([])
//     const [firstTimeChartData, setFirstTimeChartData] = useState([])
//     const [engagedChartData, setEngagedChartData] = useState([])
//     const [resourceAwailedChartData, setResourceAwailedChartData] = useState([])
//     const [firstTimeProgramData, setFirstTimeProgramData] = useState([])
//     const [engagedUserProgramData, setEngagedUserProgramData] = useState([])
//     const [firstTimeProgramName, setFirstTimeProgramName] = useState([])
//     const [engagedProgramName, setEngagedProgramName] = useState([])
//     const [newModal, setNewModal] = useState(false)
//     const [partnerListdata, setPartnerListData] = useState([])
//     const [programListdata, setProgramListData] = useState([])
//     const [sourceListData, setSourceListData] = useState([])
//     const [mediumListData, setMediumListData] = useState([])
//     const [rawSourceMediumData, setRawSourceMediumData] = useState([])
//     const [sourceListDataEu, setSourceListDataEu] = useState([])
//     const [mediumListDataEu, setMediumListDataEu] = useState([])
//     const [rawSourceMediumDataEu, setRawSourceMediumDataEu] = useState([])

//     const [ftuPartnerListData, setFtuPartnerListData] = useState([])
//     const [EuPartnerListData, setEuPartnerListData] = useState([])
//     const [rawFtuPartnerData, setRawFtuPartnerData] = useState([])
//     const [rawEuPartnerData, setRawEuPartnerData] = useState([])
//     const [selectedOptionsFtuPartner, setSelectedOptionsFtuPartner] = useState([]);
//     const [selectedOptionsEuPartner, setSelectedOptionsEuPartner] = useState([]);
//     const [ftuPartnerModal, setFtuPartnerModal] = useState(false)
//     const [euPartnerModal, setEuPartnerModal] = useState(false)

//     const [ftuResourceListData, setFtuResourceListData] = useState([])
//     const [EuResourceListData, setEuResourceListData] = useState([])
//     const [rawFtuResourceData, setRawFtuResourceData] = useState([])
//     const [rawEuResourceData, setRawEuResourceData] = useState([])
//     const [selectedOptionsFtuResource, setSelectedOptionsFtuResource] = useState([]);
//     const [selectedOptionsEuResource, setSelectedOptionsEuResource] = useState([]);
//     const [ftuResourceModal, setFtuResourceModal] = useState(false)
//     const [euResourceModal, setEuResourceModal] = useState(false)

//     const [ftuProgramListData, setFtuProgramListData] = useState([])
//     const [EuProgramListData, setEuProgramListData] = useState([])
//     const [rawFtuProgramData, setRawFtuProgramData] = useState([])
//     const [rawEuProgramData, setRawEuProgramData] = useState([])
//     const [selectedOptionsFtuProgram, setSelectedOptionsFtuProgram] = useState([]);
//     const [selectedOptionsEuProgram, setSelectedOptionsEuProgram] = useState([]);
//     const [ftuProgramModal, setFtuProgramModal] = useState(false)
//     const [euProgramModal, setEuProgramModal] = useState(false)

//     const [partnerTableData, setPartnerTableData] = useState([])
//     const [programTableData, setProgramTableData] = useState([])

//     const [selectedOptions, setSelectedOptions] = useState([]);
//     const partnerListUpdated = []

//     const [selectedOptionsProgram, setSelectedOptionsProgram] = useState([])
//     const programListUpdated = []

//     const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
//     const sourceListUpdated = []

//     const [selectedOptionsMedium, setSelectedOptionsMedium] = useState([]);
//     const mediumListUpdated = []

//     const [selectedOptionsSourceEu, setSelectedOptionsSourceEu] = useState([]);

//     const [selectedOptionsMediumEu, setSelectedOptionsMediumEu] = useState([]);


//     const [isPartnerData, setIsPartnerData] = useState(false)
//     const [isProgramData, setIsProgramData] = useState(false)

//     // Source and Medium Model

//     const [sourceModel, setSourceModel] = useState(false)
//     const [sourceModelEu, setSourceModelEu] = useState(false)

//     const [selectedOptionsMergedPartner, setSelectedOptionsMergedPartner] = useState([]);
//     const [selectedOptionsMergedProgram, setSelectedOptionsMergedProgram] = useState([]);
//     const [selectedOptionsMergedResource, setSelectedOptionsMergedResource] = useState([]);
//     const [selectedOptionsMergedPartnerResource, setSelectedOptionsMergedPartnerResource] = useState([]);
//     const [selectedOptionsMergedPartnerResourceEu, setSelectedOptionsMergedPartnerResourceEu] = useState([]);
//     const [selectedOptionsMergedProgramResource, setSelectedOptionsMergedProgramResource] = useState([]);
//     const [selectedOptionsMergedProgramResourceEu, setSelectedOptionsMergedProgramResourceEu] = useState([]);
//     const [selectedOptionsMergedSourceMedium, setSelectedOptionsMergedSourceMedium] = useState([]);
//     const [selectedOptionsMergedSourceMediumEu, setSelectedOptionsMergedSourceMediumEu] = useState([]);

//     const [isProgramManagerDashboard, setIsProgramManagerDashboard] = useState(false)

//     const goToProgramManagerDashboard = () => {
//         setIsProgramManagerDashboard(!isProgramManagerDashboard)
//     }

//     const handleSelect = (selected) => {
//         setSelectedOptions(selected);
//     };

//     const handleSelectSource = (selected) => {
//         setSelectedOptionsSource(selected)
//     }

//     useEffect(() => {
//         if(selectedOptionsSource.length > 0){
//             const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
//         console.log("Filt Data",filteredData);
//         let arr1 = [] 
//         filteredData.map((ele) => {
//           if(ele.medium_name != "" && ele.medium_name != null) {
//             arr1.push(ele.medium_name)
//           }  
//         });
//         setMediumListData(arr1);
//         } else {
//             const mediumNames = rawSourceMediumData.reduce((uniqueNames, row) => {
//                 if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
//                   uniqueNames.push(row.medium_name);
//                 }
//                 return uniqueNames;
//               }, []);
//               setMediumListData(mediumNames)
//         }
//       }, [selectedOptionsSource, rawSourceMediumData]);

//     const handleSelectMedium = (selected) => {
//         setSelectedOptionsMedium(selected)
//     }

//     useEffect(() => {
//         if(selectedOptionsMedium.length > 0){
//             const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
//             console.log("Filt Data",filteredData1);
//         let arr2 = [] 
//         filteredData1.map((ele) => {
//           if(ele.sourse_name != "" && ele.sourse_name != null) {
//             arr2.push(ele.sourse_name)
//           }  
//         });
//         setSourceListData(arr2);
//         } else {
//             const sourceNames = rawSourceMediumData.reduce((uniqueNames, row) => {
//                 if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
//                   uniqueNames.push(row.sourse_name);
//                 }
//                 return uniqueNames;
//               }, []);
//               setSourceListData(sourceNames)
//         }
//       }, [selectedOptionsMedium, rawSourceMediumData]);

//     const handleSelectSourceEu = (selected) => {
//         setSelectedOptionsSourceEu(selected)
//     }

//     useEffect(() => {
//         if(selectedOptionsSourceEu.length > 0){
//             const filteredData = rawSourceMediumDataEu.filter(obj => selectedOptionsSourceEu.some(item => item.value === obj.sourse_name));
//         console.log("Filt Data",filteredData);
//         let arr3 = [] 
//         filteredData.map((ele) => {
//           if(ele.medium_name != "" && ele.medium_name != null) {
//             arr3.push(ele.medium_name)
//           }  
//         });
//         setMediumListDataEu(arr3);
//         } else {
//             const mediumNames = rawSourceMediumDataEu.reduce((uniqueNames, row) => {
//                 if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
//                   uniqueNames.push(row.medium_name);
//                 }
//                 return uniqueNames;
//               }, []);
//               setMediumListDataEu(mediumNames)
//         }
//       }, [selectedOptionsSourceEu, rawSourceMediumDataEu]);

//     const handleSelectMediumEu = (selected) => {
//         setSelectedOptionsMediumEu(selected)
//     }

//     useEffect(() => {
//         if(selectedOptionsMediumEu.length > 0){
//             const filteredData1 = rawSourceMediumDataEu.filter(obj => selectedOptionsMediumEu.some(item => item.value === obj.medium_name));
//             console.log("Filt Data",filteredData1);
//         let arr2 = [] 
//         filteredData1.map((ele) => {
//           if(ele.sourse_name != "" && ele.sourse_name != null) {
//             arr2.push(ele.sourse_name)
//           }  
//         });
//         setSourceListDataEu(arr2);
//         } else {
//             const sourceNames = rawSourceMediumDataEu.reduce((uniqueNames, row) => {
//                 if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
//                   uniqueNames.push(row.sourse_name);
//                 }
//                 return uniqueNames;
//               }, []);
//               setSourceListDataEu(sourceNames)
//         }
//       }, [selectedOptionsMediumEu, rawSourceMediumDataEu]);

//     const handleSelectProgram = (selected) => {
//         setSelectedOptionsProgram(selected);
//     };

//     const handleFtuPartnerSelect = (selected) => {
//         setSelectedOptionsFtuPartner(selected)
//     }

//     const handleEuPartnerSelect = (selected) => {
//         setSelectedOptionsEuPartner(selected)
//     }

//     const handleFtuResourceSelect = (selected) => {
//         setSelectedOptionsFtuResource(selected)
//     }

//     const handleEuResourceSelect = (selected) => {
//         setSelectedOptionsEuResource(selected)
//     }

//     const handleFtuProgramSelect = (selected) => {
//         setSelectedOptionsFtuProgram(selected)
//     }

//     const handleEuProgramSelect = (selected) => {
//         setSelectedOptionsEuProgram(selected)
//     }

//     const openFilterModalisTrue = () => {
//         setNewModal(true)
//     }

//     const openFilterModalisFalse = () => {
//         setNewModal(false)
//     }

//     const openSourceModalisTrue = () => {
//         setSourceModel(true)
//     }

//     const openSourceModalisFalse = () => {
//         setSourceModel(false)
//     }

//     const openSourceModalisTrueEu = () => {
//         setSourceModelEu(true)
//     }

//     const openSourceModalisFalseEu = () => {
//         setSourceModelEu(false)
//     }

//     const openFtuPartnerModalisTrue = () => {
//         setFtuPartnerModal(true)
//     }

//     const openFtuPartnerModalisFalse = () => {
//         setFtuPartnerModal(false)
//     }

//     const openEuPartnerModalisTrue = () => {
//         setEuPartnerModal(true)
//     }

//     const openEuPartnerModalisFalse = () => {
//         setEuPartnerModal(false)
//     }

//     const openFtuResourceModalisTrue = () => {
//         setFtuResourceModal(true)
//     }

//     const openFtuResourceModalisFalse = () => {
//         setFtuResourceModal(false)
//     }

//     const openEuResourceModalisTrue = () => {
//         setEuResourceModal(true)
//     }

//     const openEuResourceModalisFalse = () => {
//         setEuResourceModal(false)
//     }

//     const openFtuProgramModalisTrue = () => {
//         setFtuProgramModal(true)
//     }

//     const openFtuProgramModalisFalse = () => {
//         setFtuProgramModal(false)
//     }

//     const openEuProgramModalisTrue = () => {
//         setEuProgramModal(true)
//     }

//     const openEuProgramModalisFalse = () => {
//         setEuProgramModal(false)
//     }

//     // useEffect(() => {
//     //     localStorage.setItem('fromDate', fromDate);
//     //   }, [fromDate]);

//     //   useEffect(() => {
//     //     localStorage.setItem('toDate', toDate);
//     //   }, [toDate]);

//     const ondatechange = (key, date) => {
//         if (key === "fromDate") {
//             setfromDate(date)

//         } else if (key === "toDate") {
//             settoDate(date)

//         }
//     };

//     const dateAdjusted = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     // toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
//                     toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const dateAdjusted1 = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
//                     toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const PartnerList = ["Whatsapp", "Facebook", "WEP", "Linkedin Marketing", "desh foundation", "GMBP", "EJM", "meetups", "Youtube"]

//     const ProgramList = ["New - Social Champ 1 hour Workshop", "Coach connect", "Social Champ", "Go Digital", "Social Champ Package - Digital Marketing Genius", "BLRP Orientation", "Business Loan Sarathi Package", "Free Sales Program", "Google My Business Listing for Open Market"]

//     const ProgramDataStructure = [
//         {
//             programName: "New Program",
//             partnerData: [
//                 {
//                     resourceName: null,
//                     count: 900,
//                     count2: 800
//                 },
//                 {
//                     resourceName: "Facebook",
//                     count: 700,
//                     count2: 800
//                 },
//                 {
//                     resourceName: "Instagram",
//                     count: 500,
//                     count2: 800
//                 },
//             ]
//         },
//         {
//             programName: "Old Program",
//             partnerData: [
//                 {
//                     resourceName: "Whatsapp",
//                     count: 100,
//                     count2: 800
//                 },
//                 {
//                     resourceName: "Facebook",
//                     count: 200,
//                     count2: 800
//                 },
//                 {
//                     resourceName: null,
//                     count: 400,
//                     count2: 800
//                 },
//             ]
//         },
//         {
//             programName: "Very Old Program",
//             partnerData: [
//                 {
//                     resourceName: "Linkedin",
//                     count: 100,
//                     count2: 800
//                 },
//                 {
//                     resourceName: "Messanger",
//                     count: 200,
//                     count2: 800
//                 },
//                 {
//                     resourceName: "WEP",
//                     count: 400,
//                     count2: 800
//                 },
//             ]
//         }
//     ]

//     const ProgramData1 = [
//         {
//             sPackageTitle: "Business Loan Sarathi Package",
//             partnerData: [
//                 {
//                     sEntryPoint: "",
//                     engaged_services_count: 9,
//                     first_time_services_count: 1
//                 }
//             ]
//         },
//         {
//             sPackageTitle: "Business Loan",
//             partnerData: [
//                 {
//                     sEntryPoint: "Whatsapp",
//                     engaged_services_count: 8,
//                     first_time_services_count: 5
//                 }
//             ]
//         }
//     ]

//     const arr = []
//     const [isDateSelected, setIsDateSelected] = useState(false);
//     const [partnerDataProgramManager, setPartnerDataProgramManager] = useState([])
//     const [resourceDataSelectedPartner, setResourceDataSelectedPartner] = useState([])
//     const [selectedProgramManager, setSelectedProgramManager] = useState([])
//     const [selectedPartnerName, setSelectedPartnerName] = useState('')

//     const [programDataManager, setProgramDataManager] = useState([])
//     const [partnerDataForSelectedProgram, setPartnerDataForSelectedProgram] = useState([])
//     const [selectedProgramName, setSelectedProgramName] = useState('')

//     const getProgramManagerData = (ele) => {
//         let filterParameters = {}

//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }

//         // if(selectedProgramManager){
//         //     filterParameters.sProgramManager = selectedProgramManager.value
//         // }
//         setPartnerDataProgramManager([])
//         const {tempPartnerDataForProgramManager} = api.partnerDataForProgramManager({ ...filterParameters, sProgramManager: ele.value })
//         .then(({data}) => {
//             if(data.length > 0) {
//                 console.log("Here", data)
//                 setPartnerDataProgramManager(data)
//             } else {
//                 console.log("there", data)
//                 setPartnerDataProgramManager([{
//                     sEntryPoint: "No Data Available",
//                     FTU_Count: 0,
//                     EU_Count: 0
//                 }])
//             }

//         })

//     }

//     const getProgramDataforManager = (ele) => {
//         let filterParameters = {}

//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }
//         setProgramDataManager([])
//         const {tempProgramDataForManager} = api.programDataForProgramManager({ ...filterParameters, sProgramManager: ele.value })
//         .then(({data})=> {
//             if(data.length > 0){
//                 setProgramDataManager(data)
//             } else{
//                 setProgramDataManager([{
//                     sPackageTitle: 'No Data Available',
//                     FTU_Count: 0,
//                     EU_Count: 0
//                 }])
//             }
//             console.log("Program Main Data", data)

//         })
//     }

//     const getResourceDataForSelectedPartner = (manager, partner) => {
//         let filterParameters = {}
//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }
//         setResourceDataSelectedPartner([])
//         const {tempResourceDataForSelectedPartner} = api.resourceDataForSelectedPartner({ ...filterParameters, sProgramManager: manager, sEntryPoint: partner })
//         .then(({data}) => {
//             console.log("Res Data",data)
//             setResourceDataSelectedPartner(data)
//         })
//     }

//     const getPartnerDataForSelectedProgram = (manager, program) => {
//         let filterParameters = {}
//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }
//         setPartnerDataForSelectedProgram([])
//         const {tempPartnerDataForSelectedProgram} = api.partnerDataForSelectedPro({ ...filterParameters, sProgramManager: manager, sPackageTitle: program })
//         .then(({data}) => {
//             setPartnerDataForSelectedProgram(data)
//         })
//     }

//     const getTableData = () => {
//         let filterParameters = {}

//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }

//         if(fromDate && toDate){
//             setIsDateSelected(true)
//         } else {
//             setIsDateSelected(false)
//         }


//         console.log(filterParameters, "FilterData");

//         const { tempPartner } = api.getFirstTimeUserPartnerData().then(({ data }) => {
//             if (data) {
//                 setPartnerListData(data)
//             }
//         })

//         const { tempProgram } = api.getFirstTimeProgramData({
//             fromDate: dateAdjusted1(fromDate),
//             toDate: dateAdjusted(toDate)
//         }).then(({ data }) => {
//             if (data) {
//                 // console.log("tempProgram",data)
//                 setFirstTimeProgramName(data)
//             }
//         })
//         const { tempProgram1 } = api.getEngagedUserProgramData({
//             fromDate: dateAdjusted1(fromDate),
//             toDate: dateAdjusted(toDate)
//         }).then(({ data }) => {
//             if (data) {
//                 console.log("tempProg",data)
//                 setEngagedProgramName(data)
//             }
//         })

//         const {tempsourceftu} = api.getFirstTimeSourceMediumData().then(({data}) => {
//             if(data){
//                 const sourceNames = data.reduce((uniqueNames, row) => {
//                     if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
//                       uniqueNames.push(row.sourse_name);
//                     }
//                     return uniqueNames;
//                   }, []);
//                   setSourceListData(sourceNames)

//                   const mediumNames = data.reduce((uniqueNames, row) => {
//                     if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
//                       uniqueNames.push(row.medium_name);
//                     }
//                     return uniqueNames;
//                   }, []);
//                   setMediumListData(mediumNames)
//             }
//         })

//         const {tempsourceEu} = api.getEngagedSourceMediumData().then(({data}) => {
//             if(data){
//                 const sourceNames = data.reduce((uniqueNames, row) => {
//                     if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
//                       uniqueNames.push(row.sourse_name);
//                     }
//                     return uniqueNames;
//                   }, []);
//                   setSourceListDataEu(sourceNames)

//                   const mediumNames = data.reduce((uniqueNames, row) => {
//                     if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
//                       uniqueNames.push(row.medium_name);
//                     }
//                     return uniqueNames;
//                   }, []);
//                   setMediumListDataEu(mediumNames)
//             }
//         })

//         if (programListUpdated.length != 0 && partnerListUpdated.length != 0) {
//             const { tempServices15 } = api.getFilterPartnerData({ ...filterParameters, partner: partnerListUpdated })
//                 .then(({ data }) => {
//                     if (data) {
//                         setPartnerTableData(data)
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })

//             const { tempServices16 } = api.getFilterProgramData({ ...filterParameters, program: programListUpdated })
//                 .then(({ data }) => {
//                     if (data) {
//                         setProgramTableData(data)
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         } else if (programListUpdated.length != 0) {
//             const { tempServices16 } = api.getFilterProgramData({ ...filterParameters, program: programListUpdated })
//                 .then(({ data }) => {
//                     if (data) {
//                         if(data.length > 0){
//                             setProgramTableData(data)
//                         } else {
//                             setProgramTableData([''])
//                         }
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         } else if (partnerListUpdated.length != 0) {
//             const { tempServices15 } = api.getFilterPartnerData({ ...filterParameters, partner: partnerListUpdated })
//                 .then(({ data }) => {
//                     if (data) {
//                         if(data.length > 0){
//                             setPartnerTableData(data)
//                         }else {
//                             setPartnerTableData(arr)
//                         }
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         } else {
//             //Table Data API

//             // const { tempService } = api.getResourceCount(filterParameters).then(({ data }) => {
//             //     if (data) {
//             //         setResourceCount(data[0]);
//             //     }
//             //     else {
//             //         toast("", {
//             //             autoClose: 5000,
//             //             type: toast.TYPE.ERROR,
//             //         });
//             //     }
//             // }).catch((error) => {
//             //     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //         toast(String(error.response.data.detail), {
//             //             autoClose: 5000,
//             //             type: toast.TYPE.ERROR,
//             //         });
//             //     } else if (error.response.data.message) {
//             //         toast(String(error.response.data.message), {
//             //             autoClose: 5000,
//             //             type: toast.TYPE.ERROR,
//             //         });
//             //     }

//             // });

//             // const { tempServices } = api.getengagedusercount(filterParameters).then(({ data }) => {
//             //     if (data) {
//             //         setCountData(data[0]);
//             //     }
//             //     else {
//             //         toast("", {
//             //             autoClose: 5000,
//             //             type: toast.TYPE.ERROR,
//             //         });
//             //     }
//             // }).catch((error) => {
//             //     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //         toast(String(error.response.data.detail), {
//             //             autoClose: 5000,
//             //             type: toast.TYPE.ERROR,
//             //         });
//             //     } else if (error.response.data.message) {
//             //         toast(String(error.response.data.message), {
//             //             autoClose: 5000,
//             //             type: toast.TYPE.ERROR,
//             //         });
//             //     }

//             // });

//             // const { tempServices1 } = api.getFirstTimeusersDashboradData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setFtuGridData(data)
//             //             setRawFtuResourceData(data)
//             //             const sourceNames = data.reduce((uniqueNames, row) => {
//             //         if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
//             //           uniqueNames.push(row.resourse_name);
//             //         }
//             //         return uniqueNames;
//             //       }, []);
//             //       setFtuResourceListData(sourceNames)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices2 } = api.getEngagedusersDashboradData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //                 setEuGridData(data)
//             //             setRawEuResourceData(data)
//             //             const sourceNames = data.reduce((uniqueNames, row) => {
//             //         if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
//             //           uniqueNames.push(row.resourse_name);
//             //         }
//             //         return uniqueNames;
//             //       }, []);
//             //       setEuResourceListData(sourceNames)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices3 } = api.getFirstTimeUserPartnerData({ ...filterParameters })
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setFirstTimePartnerData(data)
//             //             setRawFtuPartnerData(data)
//             //             const sourceNames = data.reduce((uniqueNames, row) => {
//             //                 if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
//             //                   uniqueNames.push(row.resource_name);
//             //                 }
//             //                 return uniqueNames;
//             //               }, []);
//             //               setFtuPartnerListData(sourceNames)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })


//             // const { tempServices4 } = api.getEngagedUserPartnerData({ ...filterParameters, program: programListUpdated })
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setEngagedPartner(data)
//             //             setRawEuPartnerData(data)
//             //             const sourceNames = data.reduce((uniqueNames, row) => {
//             //                 if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
//             //                   uniqueNames.push(row.resource_name);
//             //                 }
//             //                 return uniqueNames;
//             //               }, []);
//             //               setEuPartnerListData(sourceNames)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })
//             // //   }



//             // first time annual turnover (dreambig part)
//             const { tempServices5 } = api.getDreamBigFirstTimeAnnualTurnover(filterParameters)
//                 .then(({ data }) => {
//                     if (data) {
//                         setFirstTimeAnnualTurnoverData(data)
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })

//                 // engaged annual turn over data (dreambig part)
//             const { tempServices6 } = api.getDreamBigEngagedAnnualTurnover(filterParameters)
//                 .then(({ data }) => {
//                     if (data) {
//                         setEngagedAnnualTurnoverData(data)
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })

//             // const { tempServices7 } = api.getFirstTimeSourceMediumData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setFtuSourceAndMediumData(data)
//             //             setRawSourceMediumData(data)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices8 } = api.getEngagedSourceMediumData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setEngagedSourceAndMediumData(data)
//             //             setRawSourceMediumDataEu(data)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices9 } = api.getMonthWiseData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setMonthwiseData(data)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             //Chart Data API

//             // const { tempServices10 } = api.getFirstTimeUserChartData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setFirstTimeChartData(data)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices11 } = api.getEngagedUserChartData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setEngagedChartData(data)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices12 } = api.getResourceAwailedChartData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setResourceAwailedChartData(data)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices13 } = api.getFirstTimeProgramData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setFirstTimeProgramData(data)
//             //             setProgramListData(data)
//             //             setRawFtuProgramData(data)
//             //             const sourceNames = data.reduce((uniqueNames, row) => {
//             //                 if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
//             //                   uniqueNames.push(row.resource_name);
//             //                 }
//             //                 return uniqueNames;
//             //               }, []);
//             //               setFtuProgramListData(sourceNames)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//             // const { tempServices14 } = api.getEngagedUserProgramData(filterParameters)
//             //     .then(({ data }) => {
//             //         if (data) {
//             //             setEngagedUserProgramData(data)
//             //             setRawEuProgramData(data)
//             //             const sourceNames = data.reduce((uniqueNames, row) => {
//             //                 if (row.resource_name && (row.resource_name != null && row.resource_name != "") && !uniqueNames.includes(row.resource_name)) {
//             //                   uniqueNames.push(row.resource_name);
//             //                 }
//             //                 return uniqueNames;
//             //               }, []);
//             //               setEuProgramListData(sourceNames)
//             //         } else {
//             //             toast("", {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             })
//             //         }
//             //     }).catch((error) => {
//             //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
//             //             toast(String(error.response.data.detail), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         } else if (error.response.data.message) {
//             //             toast(String(error.response.data.message), {
//             //                 autoClose: 5000,
//             //                 type: toast.TYPE.ERROR,
//             //             });
//             //         }
//             //     })

//                 // first time user data (dream big part)
//                 const { tempFirstTimePartnerResource } = api.getDreamBigFirstTimePartnerResourceData(filterParameters)
//                 .then(({ data }) => {
//                     if (data) {
//                         setFirstTimePartnerResourceData(data)
//                         // setRawEuProgramData(data)
//                         // const sourceNames = data.reduce((uniqueNames, row) => {
//                         //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
//                         //       uniqueNames.push(row.resourse_name);
//                         //     }
//                         //     return uniqueNames;
//                         //   }, []);
//                         //   setEuProgramListData(sourceNames)
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })

//                 // engaged user data (dream big part)
//                 const { tempEngagedPartnerResource } = api.getDreamBigEngagedPartnerResourceData(filterParameters)
//                 .then(({ data }) => {
//                     if (data) {
//                         setEngagedPartnerResourceData(data)
//                         // setRawEuProgramData(data)
//                         // const sourceNames = data.reduce((uniqueNames, row) => {
//                         //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
//                         //       uniqueNames.push(row.resourse_name);
//                         //     }
//                         //     return uniqueNames;
//                         //   }, []);
//                         //   setEuProgramListData(sourceNames)
//                     } else {
//                         toast("", {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         })
//                     }
//                 }).catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         toast(String(error.response.data.detail), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })


//                 // const { tempFirstTimeProgramResource } = api.getFirstTimeProgramResourceData(filterParameters)
//                 // .then(({ data }) => {
//                 //     if (data) {
//                 //         setFirstTimeProgramResourceData(data)
//                 //     } else {
//                 //         toast("", {
//                 //             autoClose: 5000,
//                 //             type: toast.TYPE.ERROR,
//                 //         })
//                 //     }
//                 // }).catch((error) => {
//                 //     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                 //         toast(String(error.response.data.detail), {
//                 //             autoClose: 5000,
//                 //             type: toast.TYPE.ERROR,
//                 //         });
//                 //     } else if (error.response.data.message) {
//                 //         toast(String(error.response.data.message), {
//                 //             autoClose: 5000,
//                 //             type: toast.TYPE.ERROR,
//                 //         });
//                 //     }
//                 // })

//                 // const { tempEngagedProgramResource } = api.getEngagedProgramResourceData(filterParameters)
//                 // .then(({ data }) => {
//                 //     if (data) {
//                 //         setEngagedProgramResourceData(data)
//                 //     } else {
//                 //         toast("", {
//                 //             autoClose: 5000,
//                 //             type: toast.TYPE.ERROR,
//                 //         })
//                 //     }
//                 // }).catch((error) => {
//                 //     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                 //         toast(String(error.response.data.detail), {
//                 //             autoClose: 5000,
//                 //             type: toast.TYPE.ERROR,
//                 //         });
//                 //     } else if (error.response.data.message) {
//                 //         toast(String(error.response.data.message), {
//                 //             autoClose: 5000,
//                 //             type: toast.TYPE.ERROR,
//                 //         });
//                 //     }
//                 // })
//         }
//     }

//     const EngagedPartnerResourceData = [{
//         "entrypoint_name": "3KM",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "3KM",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 2
//     },
//     {
//         "entrypoint_name": "3KM",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "Business Performance Evaluation Tool",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 3
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 29
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "dePreneur Listing",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 18
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 4
//     },
//     {
//         "entrypoint_name": "Amazon_Saheli",
//         "resourcedisplay_name": "deAsra Business Listing",
//         "resourse_count": 6
//     },
//     {
//         "entrypoint_name": "Amazon_Saheli",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 5
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 10
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 83
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "Funding Readiness Assessment Tool",
//         "resourse_count": 2
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 74
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "Blog View",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 7
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 20
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 16
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "Social Media Marketing Checklist",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Ashwamedh Expo",
//         "resourcedisplay_name": "deAsra Business Listing",
//         "resourse_count": 17
//     },
//     {
//         "entrypoint_name": "Ashwamedh Expo",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 4
//     },
//     {
//         "entrypoint_name": "Ashwamedh Expo",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 4
//     },
//     {
//         "entrypoint_name": "Ashwamedh Expo",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 3
//     },
//     {
//         "entrypoint_name": "Ashwamedh_expo",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "AspireForHer",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "AspireForHer",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Atharva_AccFin",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 2
//     },
//     {
//         "entrypoint_name": "Atharva_AccFin",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 16
//     },
//     {
//         "entrypoint_name": "Atharva_AccFin",
//         "resourcedisplay_name": "Group Expert Consult",
//         "resourse_count": 16
//     },
//     {
//         "entrypoint_name": "Atharva_Finance",
//         "resourcedisplay_name": "Trademark Application Filing",
//         "resourse_count": 1
//     }]




//     const FirstTimePartnerResourceData = [{
//         "entrypoint_name": "3KM",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 11
//     },
//     {
//         "entrypoint_name": "3KM",
//         "resourcedisplay_name": "Sign Up",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 24
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "ABBM_Nagpur",
//         "resourcedisplay_name": "Sign Up",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Amazon_Saheli",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 3
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 88
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "Funding Readiness Assessment Tool",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Amhi_Udyogini",
//         "resourcedisplay_name": "Sign Up",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "Compare Options & Apply for MSME Business Loan",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 14
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "deAsra Program",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Ankur_Incubation",
//         "resourcedisplay_name": "FSSAI Registration",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Apple_salon",
//         "resourcedisplay_name": "Funding proposal creation",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "AspireForHer",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Atharva_AccFin",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 15
//     },
//     {
//         "entrypoint_name": "Atharva_Finance",
//         "resourcedisplay_name": "Udyam Registration Checklist",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Baramati_Business_Group",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 43
//     },
//     {
//         "entrypoint_name": "Baramati_Incubation",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Baramati_Incubation",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 13
//     },
//     {
//         "entrypoint_name": "BBN",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 103
//     },
//     {
//         "entrypoint_name": "BBNG",
//         "resourcedisplay_name": "Events Registration",
//         "resourse_count": 2
//     },
//     {
//         "entrypoint_name": "BBNG",
//         "resourcedisplay_name": "FSSAI License",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "BBN_Sangli",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "Bhadipa",
//         "resourcedisplay_name": "Compare options & Apply for MSME Business Loan",
//         "resourse_count": 19
//     },
//     {
//         "entrypoint_name": "Bhadipa",
//         "resourcedisplay_name": "Sign Up",
//         "resourse_count": 1
//     },
//     {
//         "entrypoint_name": "BITO",
//         "resourcedisplay_name": "deAsra Business Listing",
//         "resourse_count": 26
//     },
//     {
//         "entrypoint_name": "BITO",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 9
//     },
//     {
//         "entrypoint_name": "BITO",
//         "resourcedisplay_name": "dePreneur Listing",
//         "resourse_count": 8
//     },
//     {
//         "entrypoint_name": "BITO",
//         "resourcedisplay_name": "Sign Up",
//         "resourse_count": 1
//     }]


//     const firstTimeProgramResourceData1 = [  {
//         "packagetitle_name": "Taxation for MSME's",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 4
//     },
//     {
//         "packagetitle_name": "Townsquare for J4E",
//         "resourcedisplay_name": "Townsquare Service",
//         "resourse_count": 10
//     },
//     {
//         "packagetitle_name": "Understanding & Application of Finance in Business",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 9
//     },
//     {
//         "packagetitle_name": "Understanding & Application of Finance in Business 26 May",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 33
//     },
//     {
//         "packagetitle_name": "Understanding Government Schemes/Initiatives For MSMEs",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 144
//     },
//     {
//         "packagetitle_name": "Understanding Govt. Schemes and Initiatives for MSME's",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 98
//     },
//     {
//         "packagetitle_name": "Vrindavan_Banquet (3rd March 2023)",
//         "resourcedisplay_name": "Group Experts Consultation",
//         "resourse_count": 15
//     },
//     {
//         "packagetitle_name": "WhatsApp for Business - 3rd June 2022",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 48
//     },
//     {
//         "packagetitle_name": "WhatsApp for Business Training - Oct. 2022",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 19
//     },
//     {
//         "packagetitle_name": "Xpert Consultation",
//         "resourcedisplay_name": "deAsra Experts",
//         "resourse_count": 8
//     },
//     {
//         "packagetitle_name": "Xpert Consultation Package",
//         "resourcedisplay_name": "deAsra Experts",
//         "resourse_count": 4
//     },
//     {
//         "packagetitle_name": "Xpert Consultation Package",
//         "resourcedisplay_name": "Xpert Cliniq",
//         "resourse_count": 26
//     },
//     {
//         "packagetitle_name": "– All about Udyam Registration for your Business",
//         "resourcedisplay_name": "DeAsra Marketing Event",
//         "resourse_count": 3
//     }
// ] 

// const engagedProgramResourceData1 = [ {
//     "packagetitle_name": "Xpert Consultation",
//     "resourcedisplay_name": "deAsra Experts",
//     "resourse_count": 2
// },
// {
//     "packagetitle_name": "Xpert Consultation",
//     "resourcedisplay_name": "Expert Consult",
//     "resourse_count": 10
// },
// {
//     "packagetitle_name": "Xpert Consultation",
//     "resourcedisplay_name": "Expert Consultation",
//     "resourse_count": 14
// },
// {
//     "packagetitle_name": "Xpert Consultation Package",
//     "resourcedisplay_name": "Expert Consult",
//     "resourse_count": 2
// },
// {
//     "packagetitle_name": "Xpert Consultation Package",
//     "resourcedisplay_name": "Expert Consultation",
//     "resourse_count": 6
// },
// {
//     "packagetitle_name": "Xpert Consultation Package",
//     "resourcedisplay_name": "Xpert Cliniq",
//     "resourse_count": 44
// },
// {
//     "packagetitle_name": "– All about Udyam Registration for your Business",
//     "resourcedisplay_name": "DeAsra Marketing Event",
//     "resourse_count": 37
// },
// {
//     "packagetitle_name": "– All about Udyam Registration for your Business",
//     "resourcedisplay_name": "deAsra Program",
//     "resourse_count": 39
// },
// {
//     "packagetitle_name": "– All about Udyam Registration for your Business",
//     "resourcedisplay_name": "Group Expert Consult",
//     "resourse_count": 39
// }
// ]

//     const handleFilterClick = () => {
//         openFilterModalisTrue()
//     }

//     const handleSourceModelClick = () => {
//         openSourceModalisTrue()
//     }

//     const handleSourceModelClickEu = () => {
//         openSourceModalisTrueEu()
//     }

//     const handleFtuPartnerModalClick = () => {
//         openFtuPartnerModalisTrue()
//     }

//     const handleEuPartnerModalClick = () => {
//         openEuPartnerModalisTrue()
//     }

//     const handleFtuResourceModalClick = () => {
//         openFtuResourceModalisTrue()
//     }

//     const handleEuResourceModalClick = () => {
//         openEuResourceModalisTrue()
//     }

//     const handleFtuProgramModalClick = () => {
//         openFtuProgramModalisTrue()
//     }

//     const handleEuProgramModalClick = () => {
//         openEuProgramModalisTrue()
//     }

//     const partnerList1 = []
//     const programList1 = []

//     partnerListdata.map((ele) => {
//         if (ele.resource_name != null && ele.resource_name != "") {
//             partnerList1.push(ele.resource_name)
//         }
//     })

//     programListdata.map((ele) => {
//         if (ele.resource_name != null && ele.resource_name != "") {
//             programList1.push(ele.resource_name)
//         }
//     })

//     const mergedResourceNames = [];

//     // Extract resource names from the first data array
//     const resourceNames1 = firstTimeProgramName.map((item) => item.resource_name).filter((name) => name !== "" && name !== null);

//     // Extract resource names from the second data array
//     const resourceNames2 = engagedProgramName.map((item) => item.resource_name).filter((name) => name !== "" && name !== null);


//     // Merge the resource names and remove duplicates
//     const mergedResourceNamesSet = new Set([...resourceNames1, ...resourceNames2]);
//     mergedResourceNames.push(...mergedResourceNamesSet);

//     console.log("M++",mergedResourceNames);

//     const handleSourceFilterSearchClick = () => {
//         const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
//         const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
//         const filteredData2 = rawSourceMediumData.filter(obj =>
//             selectedOptionsSource.some(item => item.value === obj.sourse_name) &&
//             selectedOptionsMedium.some(item => item.value === obj.medium_name)
//         );

//         if (selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0) {
//             if(filteredData2.length > 0){
//                 setFtuSourceAndMediumData(filteredData2)
//             } else{
//                 setFtuSourceAndMediumData([{
//                     sourse_name: "No Data Available",
//                     medium_name: " ",
//                     resourse_count: ""
//                 }])
//             }
//             openSourceModalisFalse()
//         } else if (selectedOptionsSource.length > 0) {
//             setFtuSourceAndMediumData(filteredData)
//             console.log("test", ftuSourceAndMediumData)
//             openSourceModalisFalse()
//         } else if (selectedOptionsMedium.length > 0) {
//             setFtuSourceAndMediumData(filteredData1)
//             console.log("test1", ftuSourceAndMediumData)
//             openSourceModalisFalse()
//         } else {
//             setFtuSourceAndMediumData(rawSourceMediumData)
//             openSourceModalisFalse()
//         }
//     }

//     const handleSourceFilterSearchClickEu= () => {
//         const filteredData = rawSourceMediumDataEu.filter(obj => selectedOptionsSourceEu.some(item => item.value === obj.sourse_name));
//         const filteredData1 = rawSourceMediumDataEu.filter(obj => selectedOptionsMediumEu.some(item => item.value === obj.medium_name));
//         const filteredData2 = rawSourceMediumDataEu.filter(obj =>
//             selectedOptionsSourceEu.some(item => item.value === obj.sourse_name) &&
//             selectedOptionsMediumEu.some(item => item.value === obj.medium_name)
//         );

//         if (selectedOptionsSourceEu.length > 0 && selectedOptionsMediumEu.length > 0) {
//             if(filteredData2.length > 0){
//                 setEngagedSourceAndMediumData(filteredData2)
//             } else{
//                 setEngagedSourceAndMediumData([{
//                     sourse_name: "No Data Available",
//                     medium_name: " ",
//                     resourse_count: ""
//                 }])
//             }
//             openSourceModalisFalseEu()
//         } else if (selectedOptionsSourceEu.length > 0) {
//             setEngagedSourceAndMediumData(filteredData)
//             openSourceModalisFalseEu()
//         } else if (selectedOptionsMediumEu.length > 0) {
//             setEngagedSourceAndMediumData(filteredData1)
//             openSourceModalisFalseEu()
//         } else {
//             setEngagedSourceAndMediumData(rawSourceMediumDataEu)
//             openSourceModalisFalseEu()
//         }
//     }

//     const handleFtuFilterSearchClick = () => {
//         const filteredData = rawFtuPartnerData.filter(obj => selectedOptionsFtuPartner.some(item => item.value === obj.resource_name));
//         if(selectedOptionsFtuPartner.length > 0){
//             if(filteredData.length > 0){
//                 setFirstTimePartnerData(filteredData)
//             } else {
//                 setFirstTimePartnerData([{
//                     resource_name: "No Data Available",
//                     resource_count: ''
//                 }])
//             }
//             openFtuPartnerModalisFalse()                   
//         } else {
//                 setFirstTimePartnerData(rawFtuPartnerData)
//                 openFtuPartnerModalisFalse()
//         }
//     }

//     const handleEuFilterSearchClick = () => {
//         const filteredData = rawEuPartnerData.filter(obj => selectedOptionsEuPartner.some(item => item.value === obj.resource_name));
//         if(selectedOptionsEuPartner.length > 0){
//             if(filteredData.length > 0){
//                 setEngagedPartner(filteredData)

//             } else {
//                 setEngagedPartner([{
//                     resource_name: "No Data Available",
//                     resource_count: ''
//                 }])
//             }   
//             openEuPartnerModalisFalse()        
//         } else {
//                 setEngagedPartner(rawEuPartnerData)
//                 openEuPartnerModalisFalse()
//         }
//     }

//     const handleFtuResourceFilterSearchClick = () => {
//         const filteredData = rawFtuResourceData.filter(obj => selectedOptionsFtuResource.some(item => item.value === obj.resourse_name));
//         if(selectedOptionsFtuResource.length > 0){
//             if(filteredData.length > 0){
//                 setFtuGridData(filteredData)
//             } else {
//                 setFtuGridData([{
//                     resourse_name: "No Data Available",
//                     resourse_count: ''
//                 }])
//             }
//                 openFtuResourceModalisFalse()            
//         } else {
//                 setFtuGridData(rawFtuResourceData)
//                 openFtuResourceModalisFalse()
//         }
//     }

//     const handleEuResourceFilterSearchClick = () => {
//         const filteredData = rawEuResourceData.filter(obj => selectedOptionsEuResource.some(item => item.value === obj.resourse_name));
//         if(selectedOptionsEuResource.length > 0){
//             if(filteredData.length > 0){
//                 setEuGridData(filteredData)
//             } else {
//                 setEuGridData([{
//                     resourse_name: "No Data Available",
//                     resourse_count: ''
//                 }])
//             }
//                 openEuResourceModalisFalse()            
//         } else {
//                 setEuGridData(rawEuResourceData)
//                 openEuResourceModalisFalse()
//         }
//     }

//     const handleFtuProgramFilterSearchClick = () => {
//         const filteredData = rawFtuProgramData.filter(obj => selectedOptionsFtuProgram.some(item => item.value === obj.resource_name));
//         if(selectedOptionsFtuProgram.length > 0){
//             if(filteredData.length > 0) {
//                 setFirstTimeProgramData(filteredData)
//             }else {
//                 setFirstTimeProgramData([{
//                     resource_name: "No Data Available",
//                     resource_count: ''
//                 }])
//             }
//                 openFtuProgramModalisFalse()            
//         } else {
//                 setFirstTimeProgramData(rawFtuProgramData)
//                 openFtuProgramModalisFalse()
//         }
//         console.log("Filtered Data", firstTimeProgramData)
//     }

//     const handleEuProgramFilterSearchClick = () => {
//         const filteredData = rawEuProgramData.filter(obj => selectedOptionsEuProgram.some(item => item.value === obj.resource_name));
//         if(selectedOptionsEuProgram.length > 0){
//             if(filteredData.length > 0){
//                 setEngagedUserProgramData(filteredData)
//             } else{
//                 setEngagedUserProgramData([{
//                     resource_name: "No Data Available",
//                     resource_count: ''
//                 }])
//             }
//                 openEuProgramModalisFalse()            
//         } else {
//                 setEngagedUserProgramData(rawEuProgramData)
//                 openEuProgramModalisFalse()
//         }
//     }

//     const [isClearClicked, setIsClearClicked] = useState(false);

//     const handleClearClick = () => {
//         if(!isProgramManagerDashboard){
//             setSelectedOptions([])

//         setFtuGridData([])
//         setEuGridData([])
//         setFirstTimePartnerData([])
//         setEngagedPartner([])
//         setFirstTimeAnnualTurnoverData([])
//         setEngagedAnnualTurnoverData([])
//         setFtuSourceAndMediumData([])
//         setEngagedSourceAndMediumData([])
//         setFirstTimeChartData([])
//         setEngagedChartData([])
//         setResourceAwailedChartData([])
//         setFirstTimeProgramData([])
//         setEngagedUserProgramData([])
//         setPartnerTableData([])
//         setProgramTableData([])
//         setFirstTimePartnerResourceData([])
//         setEngagedPartnerResourceData([])
//         setFirstTimeProgramResourceData([])
//         setEngagedProgramResourceData([])

//         setSelectedOptionsProgram([])
//         setfromDate()
//         settoDate()
//         setSelectedOptionsSource([])
//         setSelectedOptionsMedium([])
//         setSelectedOptionsSourceEu([])
//         setSelectedOptionsMediumEu([])
//         setSelectedOptionsEuPartner([])
//         setSelectedOptionsFtuPartner([])
//         setSelectedOptionsEuResource([])
//         setSelectedOptionsFtuResource([])
//         setSelectedOptionsEuProgram([])
//         setSelectedOptionsFtuProgram([])
//         setSelectedOptionsMergedPartner([])
//         setSelectedOptionsMergedProgram([])
//         setSelectedOptionsMergedResource([])
//         setSelectedOptionsMergedPartnerResource([])
//         setSelectedOptionsMergedPartnerResourceEu([])
//         setSelectedOptionsMergedProgramResource([])
//         setSelectedOptionsMergedProgramResourceEu([])
//         setSelectedOptionsMergedSourceMedium([])
//         setSelectedOptionsMergedSourceMediumEu([])
//         setIsProgramData(false);
//         setIsClearClicked(true); 
//         localStorage.removeItem("fromDate")
//     localStorage.removeItem("toDate")
//         } else {
//         setfromDate()
//         settoDate()
//         setSelectedProgramManager([])
//         setPartnerDataProgramManager([])
//         setProgramDataManager([])
//         localStorage.removeItem("fromDate")
//         localStorage.removeItem("toDate")
//         // if(selectedProgramManager){
//         //     getProgramManagerData(selectedProgramManager)
//         // }

//         }
//     }   

//     useEffect(() => {
//         if (isClearClicked) {
//           getTableData(); // Call getTableData when isClearClicked is true
//           setIsClearClicked(false); // Reset the clear flag to false
//         }
//       }, [isClearClicked]);

//     const handleFilterByModalClearClick = () => {
//         setSelectedOptions([])
//         setSelectedOptionsProgram([])
//         setfromDate()
//         settoDate()

//     }

//     const handleEuSourceFilterClearClick = () => {
//         setSelectedOptionsSourceEu([])
//         setSelectedOptionsMediumEu([])
//     } 

//     const handleFtuSourceFilterClearClick = () => {
//         setSelectedOptionsSource([])
//         setSelectedOptionsMedium([])
//     } 

//     const handleEuPartnerFilterClearClick = () => {
//         setSelectedOptionsEuPartner([])
//     } 

//     const handleFtuPartnerFilterClearClick = () => {
//         setSelectedOptionsFtuPartner([])
//     }

//     const handleEuResourceFilterClearClick = () => {
//         setSelectedOptionsEuResource([])
//     } 

//     const handleFtuResourceFilterClearClick = () => {
//         setSelectedOptionsFtuResource([])
//     }

//     const handleEuProgramFilterClearClick = () => {
//         setSelectedOptionsEuProgram([])
//     } 

//     const handleFtuProgramFilterClearClick = () => {
//         setSelectedOptionsFtuProgram([])
//     }

//     useEffect(() => {
//         const handleBeforeUnload = () => {
//           localStorage.removeItem('fromDate');
//           localStorage.removeItem('toDate')
//         };
//         window.addEventListener('beforeunload', handleBeforeUnload);

//         return () => {
//           window.removeEventListener('beforeunload', handleBeforeUnload);
//         };
//       }, []);

//     const handleSearchClick = async () => {
//         if(!fromDate && !toDate){
//             localStorage.removeItem("fromDate")
//             localStorage.removeItem("toDate")
//         }
//         fromDate && localStorage.setItem("fromDate", fromDate.toLocaleDateString("en-GB"))
//         toDate && localStorage.setItem("toDate", toDate.toLocaleDateString("en-GB"))

//         if(!isProgramManagerDashboard){

//             selectedOptions.map((ele) => {
//                 partnerListUpdated.push(ele.value)
//             })
//             partnerListUpdated.map((ele) => {
//                 arr.push(
//                     {
//                         resource_name: ele,
//                         First_Time_Usres: 0,
//                         Engaged_Users: 0
//                     }
//                 )
//             })

//             console.log("Np", arr)

//             selectedOptionsProgram.map((element) => {
//                 programListUpdated.push(element.value)
//             })

//             // const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
//             // const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
//             // const filteredData2 = rawSourceMediumData.filter(obj => 
//             //     selectedOptionsSource.some(item => item.value === obj.sourse_name) && 
//             //     selectedOptionsMedium.some(item => item.value === obj.medium_name)
//             //   );
//             setIsPartnerData(selectedOptions.length !== 0, () => {
//                 console.log('isPartnerData:', isPartnerData);
//             });
//             setIsProgramData(selectedOptionsProgram.length !== 0, () => {
//                 console.log('isProgramData:', isProgramData);
//             });
//             // if(selectedOptionsSource.length > 0 && !selectedOptionsMedium){
//             //     setFtuSourceAndMediumData(filteredData) 
//             //     console.log("test",ftuSourceAndMediumData)
//             //     openFilterModalisFalse()
//             // } else if(selectedOptionsMedium.length > 0 && !selectedOptionsSource){
//             //     setFtuSourceAndMediumData(filteredData1) 
//             //     console.log("test1",ftuSourceAndMediumData)
//             //     openFilterModalisFalse()
//             // } else if(selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0){
//             //     setFtuSourceAndMediumData(filteredData2)
//             //     openFilterModalisFalse()
//             // }
//             // if(selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0){
//             //         setFtuSourceAndMediumData(filteredData2)
//             //         openFilterModalisFalse()
//             //     }else if(selectedOptionsSource.length > 0){
//             //             setFtuSourceAndMediumData(filteredData) 
//             //             console.log("test",ftuSourceAndMediumData)
//             //             openFilterModalisFalse()
//             //         } else if(selectedOptionsMedium.length > 0){
//             //             setFtuSourceAndMediumData(filteredData1) 
//             //             console.log("test1",ftuSourceAndMediumData)
//             //             openFilterModalisFalse()
//             //         } else{

//             openFilterModalisFalse()
//             setFtuGridData([])
//             setEuGridData([])
//             setFirstTimePartnerData([])
//             setEngagedPartner([])
//             setFirstTimeAnnualTurnoverData([])
//             setEngagedAnnualTurnoverData([])
//             setFtuSourceAndMediumData([])
//             setEngagedSourceAndMediumData([])
//             setFirstTimeChartData([])
//             setEngagedChartData([])
//             setResourceAwailedChartData([])
//             setFirstTimeProgramData([])
//             setEngagedUserProgramData([])
//             setPartnerTableData([])
//             setProgramTableData([])
//             setFirstTimePartnerResourceData([])
//             setEngagedPartnerResourceData([])
//             setFirstTimeProgramResourceData([])
//             setEngagedProgramResourceData([])
//             getTableData()
//         }else{
//             openFilterModalisFalse()
//             if(selectedProgramManager){
//                 getProgramManagerData(selectedProgramManager)
//                 getProgramDataforManager(selectedProgramManager)
//             }
//             // if(selectedPartnerName){
//             //     getResourceDataForSelectedPartner(selectedProgramManager.value, selectedPartnerName)
//             // }

//             // if(selectedProgramName){
//             //     getPartnerDataForSelectedProgram(selectedProgramManager.value, selectedProgramName)
//             // }

//         }
//         // }
//     }

//     useEffect(() => {
//         getTableData()
//     }, [])    

//     return (
//         <div>
//             <div className={`${!isPartnerData && !isProgramData ? "row mt-3 mb-4" : "row mt-2"}`}>


//                 {/* <div className="col-2">
//                     {
//                         !isPartnerData && !isProgramData ?
//                             <div style={{
//                                 backgroundColor: '#78417C',
//                                 color: "#fff"
//                             }} className="esp-dashboard-card conv-text-center"
//                             title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                             >
//                                 <label className="esp-box-header-title">All time FTU</label>
//                                 <h5 className="esp-count-text1">{TotalFirstTimeUserCount || 0}</h5>
//                                 <div style={{ clear: "both" }}></div>
//                             </div>
//                             :
//                             ""
//                     }
//                 </div> */}

//                 {/* <div className="col-2">
//                     {
//                         !isPartnerData && !isProgramData ?
//                             <div style={{
//                                 backgroundColor: '#78417C',
//                                 color: "#fff"
//                             }} className="esp-dashboard-card conv-text-center"
//                             title='Displays the Count of Engaged Users where mobile number is mandatory + all the count before that.'
//                             >
//                                 <label className="esp-box-header-title">All time EU</label>
//                                 <h5  className="esp-count-text1" style={{
//                                     color: "#fff !important"
//                                 }}>{TotalEngagedUserCount || 0}</h5>
//                                 <div style={{ clear: "both" }}></div>
//                             </div>
//                             :
//                             ""
//                     }
//                 </div> */}
//                 {/* <div className="col-2">
//                 {
//                         !isPartnerData && !isProgramData ?
//                             <div style={{
//                                 backgroundColor: '#78417C',
//                                 color: "#fff"
//                             }} className="esp-dashboard-card conv-text-center" 
//                             title='Displays the Count of All time Data of Resources Availed by users'>
//                                 <label className="esp-box-header-title">All Time Resources Availed</label>
//                                 <h5 className="esp-count-text1" style={{
//                                     color: "#fff !important"
//                                 }}>{TotalResourceAvailedCount || 0}</h5>
//                                 <div style={{ clear: "both" }}></div>
//                             </div>
//                             :
//                             ""
//                     }


//                 </div> */}

//                 {/* <div className="col-2">
//                 {
//                         !isPartnerData && !isProgramData ?
//                             <div className="esp-dashboard-card conv-text-center"
//                             title='Displays the Count of First Time users where mobile number is mandatory.'
//                             >
//                                 <label className="esp-box-header-title">No of FTU's</label>
//                                 <h5 className="esp-count-text"> {countData.first_time_users || 0} </h5>
//                                 <div style={{ clear: "both" }}></div>
//                             </div>
//                             :
//                             ""
//                     }

//                 </div> */}

//                 {/* <div className="col-2">
//                 {
//                         !isPartnerData && !isProgramData ?
//                             <div className="esp-dashboard-card conv-text-center" 
//                             title='Displays the Count of Engaged users where mobile number is mandatory'
//                             >
//                                 <label className="esp-box-header-title">No of EU's</label>
//                                 <h5 className="esp-count-text"> {countData.engaged_users && countData.engaged_users || 0} </h5>
//                                 <div style={{ clear: "both" }}></div>
//                             </div>
//                             :
//                             ""
//                     }
//                 </div> */}

//                 <div className="col-12" style={{backgroundColor:""}}>
//                     <Button className="esp-inline-button ml-2" style={{
//                             marginBottom: "15px"
//                         }} onClick={handleFilterClick}>
//                         <img
//                             alt=""
//                             src={ic_filter}
//                             height={"15px"}
//                             width={"15px"}
//                             className="conv-mr10"
//                         />
//                         Filter By</Button>
//                         <Button className="esp-inline-button ml-2" style={{
//                             marginBottom: "15px"
//                         }} onClick={handleClearClick}>
//                         Clear filter</Button>
//                 </div>


//             </div>

//             <a 
//                 // onClick={goToProgramManagerDashboard}  
//                 className="con-cursor-pointer" 
//                 style={{ color: "#78417C",
//                     position: 'absolute',
//                     right: 24,
//                     zIndex:1
//                 }}
//             >
//                 {isProgramManagerDashboard ?
//                 <span className='text-hover'>Go Back to Reports</span>
//                 :
//                 <span className='text-hover'>Program Manager Dashboard</span>
//                 }
//             </a>


//             <Modal isOpen={newModal}>
//                 <ModalContent className="EngagedDashboard-filter-modal">
//                     <div className="modal-header">
//                         <span className="modal-title">Filter Date Wise</span>
//                         <img
//                             alt="close"
//                             id="Close"
//                             src={close_modal}
//                             className="close modal-close"
//                             onClick={openFilterModalisFalse}
//                         />
//                     </div>

//                     <div className="modal-body">
//                         <br />
//                         <div className="row">
//                             <div className="col-6 spled-container conv-zindex">
//                                 <div className="width-100">
//                                     <ReactDatePicker
//                                         dateFormat="dd/MM/yyyy"
//                                         selected={fromDate}
//                                         onChange={(date) => ondatechange("fromDate", date)}
//                                         placeholderText="From Date"
//                                         minDate={new Date("01-01-2013")}
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-6 spled-container conv-zindex">
//                                 <div className="width-100">
//                                     <ReactDatePicker
//                                         dateFormat="dd/MM/yyyy"
//                                         selected={toDate}
//                                         onChange={(date) => ondatechange("toDate", date)}
//                                         placeholderText="To Date"
//                                         maxDate={new Date()}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                         <br />
//                         {
//                             !isProgramManagerDashboard && isDateSelected && 
//                             <div className="row">
//                             <div className="offset-3 col-6 spled-container">
//                                 <div className="width-100">
//                                     <ReactMultiSelectCheckboxes
//                                         options={mergedResourceNames.map((program) => ({
//                                             label: program,
//                                             value: program,
//                                         }))}
//                                         // placeholder="Select partners"
//                                         placeholderButtonLabel="Select programs"
//                                         value={selectedOptionsProgram}
//                                         // onChange={handleSelectProgram}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                          } 
//                         <br />
//                         <div className='row d-flex justify-content-center align-items-center'>
//                             <div className="offset-1 col-5">
//                                 <Button className="esp-inline-button" 
//                                     onClick={handleSearchClick}
//                                 >
//                                         Search
//                                 </Button>
//                             </div>
//                             <div className="col-5">
//                                 <Button className="esp-inline-button" 
//                                     onClick={handleFilterByModalClearClick}
//                                 >Clear</Button>
//                             </div>
//                             {/* <div className="col-4"></div> */}
//                         </div>

//                     </div>
//                 </ModalContent>
//             </Modal>

//             {
//                         <div>
//                             <div className="row mt-3 mb-3">
//                                 <div className="col-12">
//                                     <DreamBigMergedPartnerResourceTable 
//                                         firstTimeData={firstTimePartnerResourceData} 
//                                         engagedData={engagedPartnerResourceData} 
//                                         // selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} 
//                                         // setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} 
//                                         // selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} 
//                                         // setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} 
//                                     />
//                                 </div>
//                             </div>

//                             <div className="row mb-3">
//                                 <div className="col-12">
//                                     <DreamBigMergedTurnoverTable 
//                                         firstTimeData={firstTimeAnnualTurnoverData} 
//                                         engagedData={engagedAnnualTurnoverData}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//             }




//         </div>
//     )
// }

// export default DreamBigNewAndEngagedUserHome



/// again
import React, { useState, useRef } from 'react'
import { useEffect } from 'react';
import ReactDatePicker from "react-datepicker";
import { Button } from "../../common/Button/Button";
import api from "../../utils/api";
// import EngagedAnnualTurnover from './DreamBigEngagedAnnualTurnover'
// import EngagedPartner from './DreamBigEngagedPartner'
// import EUGrid from './DreamBigEUGrid'
// import EUSourceAndMedimGrid from './DreamBigEUSourceAndMedimGrid'
// import FirstTimeAnnualTurnover from './DreamBigFirstTimeAnnualTurnover'
// import FirstTimePartner from './DreamBigFirstTimePartner'
// import FTUGrid from './DreamBigFTUGrid'
// import FTUSourceAndMediumGrid from './DreamBigFTUSourceAndMediumGrid'
// import MonthlyDataGrid from './DreamBigMonthlyDataGrid'
// import MonthlyUserChart from './DreamBigMonthlyUserChart'
// import TotalEngagedUserChart from './DreamBigTotalEngagedUserChart'
// import TotalFirstTimeChart from './DreamBigTotalFirstTimeChart'
// import TotalResourceAwailed from './DreamBigTotalResourceAwailed'
import { toast } from 'react-toastify';
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import ic_filter from '../../assets/ic_filter.svg'
// import FirstTimeProgram from './DreamBigFirstTimeProgram';
// import EngagedUserProgram from './DreamBigEngagedUserProgram';

// import DynamicProgramTable from './DreamBigDynamicProgramTable';
import DreamBigDynamicProgramTable from './DreamBigDynamicProgramTable';

import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

// import PartnerDataTable from './DreamBigPartnerDataTable';
import DreamBigPartnerDataTable from './DreamBigPartnerDataTable';

// import MergedPartnerTable from './DreamBigMergedPartnerTable';
import DreamBigMergedPartnerTable from './DreamBigMergedPartnerTable';

// import MergedProgramTable from './DreamBigMergedProgramTable';
// import DreamBigMergedProgramTable from './DreamBigMergedProgramTable';

// import MergedResourceTable from './DreamBigMergedResourceTable';
// import DreamBigMergedResourceTable from './DreamBigMergedResourceTable';

// import MergedTurnoverTable from './DreamBigMergedTurnoverTable';
import DreamBigMergedTurnoverTable from "./DreamBigMergedTurnoverTable"

// import MergedPartnerResourceTable from './MergedPartnerResourceTable';
import DreamBigMergedPartnerResourceTable from "./DreamBigMergedPartnerResourceTable"

// import MergedSourceMediumTable from './DreamBigMergedSourceMediumTable';
// import DreamBigMergedSourceMediumTable from './DreamBigMergedSourceMediumTable';

// import MergedProgramResourceTable from './DreamBigMergedProgramResourceTable';
// import DreamBigMergedProgramResourceTable from './DreamBigMergedProgramResourceTable';

// import ProgramManagerHome from './DreamBigProgramManagerHome';
import DreamBigProgramManagerHome from './DreamBigProgramManagerHome';

import TotalResourceConsumedByUserTable from './TotalResourceConsumedByUserTable';
import TotalResourceConsumedByUserTableBefore4thApril from './TotalResourceConsumedByUserTableBefore4thApril';
import TopResources from './TopResources';
import FTUBasedOnVehicleQuestion from './FTUBasedOnVehicleQuestion';
import SourcesBasedOnEntryPointTable from './SourcesBasedOnEntryPointTable';

import DreamBigAllFilterTable from "./DreamBigAllFilterTable";

// import Modal from 'react-modal'
// import ModalContent from '../../common/Modal/ModalContent';
import Select from "react-select";
// import { Button } from '../../common/Button/Button';
import MultiSelectAll from '../../common/Multiselect/MultiSelectAll';

import Spinner from '../../common/Spinner/Spinner';
import DreamBigLandingPage from './DreamBigLandingPage';


const DreamBigNewAndEngagedUserHome = () => {

    const [countData, setCountData] = useState({
        engaged_users: 0,
        first_time_users: 0
    })
    const [resourceCount, setResourceCount] = useState({
        record_engaged_users: 0,
        first_time_users: 0,
        total: 0
    })


    // const FirstTimeAdditionalCount = 108840
    // const EngagedUserAdditionalCount = 55586
    const FirstTimeAdditionalCount = 0
    const EngagedUserAdditionalCount = 0

    const TotalFirstTimeUserCount = countData.first_time_users + FirstTimeAdditionalCount;
    const TotalEngagedUserCount = countData.engaged_users + EngagedUserAdditionalCount
    const TotalResourceAvailedCount = resourceCount.total + FirstTimeAdditionalCount + EngagedUserAdditionalCount
    const currentDateRangeResourceAvailedCount = resourceCount.total;


    const [fromDate, setfromDate] = useState();
    const [toDate, settoDate] = useState();
    const [ftuGridData, setFtuGridData] = useState([])
    const [euGridData, setEuGridData] = useState([])
    const [firstTimePartnerData, setFirstTimePartnerData] = useState([])
    const [engagedPartnerData, setEngagedPartner] = useState([])
    const [firstTimeAnnualTurnoverData, setFirstTimeAnnualTurnoverData] = useState([])
    const [engagedAnnualTurnoverData, setEngagedAnnualTurnoverData] = useState([])
    const [ftuSourceAndMediumData, setFtuSourceAndMediumData] = useState([])
    const [engagedSourceAndMediumData, setEngagedSourceAndMediumData] = useState([])
    const [monthwiseData, setMonthwiseData] = useState([])
    const [firstTimePartnerResourceData, setFirstTimePartnerResourceData] = useState([])
    const [engagedPartnerResourceData, setEngagedPartnerResourceData] = useState([])
    const [firstTimeProgramResourceData, setFirstTimeProgramResourceData] = useState([])
    const [engagedProgramResourceData, setEngagedProgramResourceData] = useState([])
    const [firstTimeChartData, setFirstTimeChartData] = useState([])
    const [engagedChartData, setEngagedChartData] = useState([])
    const [resourceAwailedChartData, setResourceAwailedChartData] = useState([])
    const [firstTimeProgramData, setFirstTimeProgramData] = useState([])
    const [engagedUserProgramData, setEngagedUserProgramData] = useState([])
    const [firstTimeProgramName, setFirstTimeProgramName] = useState([])
    const [engagedProgramName, setEngagedProgramName] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [partnerListdata, setPartnerListData] = useState([])
    const [programListdata, setProgramListData] = useState([])
    const [sourceListData, setSourceListData] = useState([])
    const [mediumListData, setMediumListData] = useState([])
    const [rawSourceMediumData, setRawSourceMediumData] = useState([])
    const [sourceListDataEu, setSourceListDataEu] = useState([])
    const [mediumListDataEu, setMediumListDataEu] = useState([])
    const [rawSourceMediumDataEu, setRawSourceMediumDataEu] = useState([])

    const [ftuPartnerListData, setFtuPartnerListData] = useState([])
    const [EuPartnerListData, setEuPartnerListData] = useState([])
    const [rawFtuPartnerData, setRawFtuPartnerData] = useState([])
    const [rawEuPartnerData, setRawEuPartnerData] = useState([])
    const [selectedOptionsFtuPartner, setSelectedOptionsFtuPartner] = useState([]);
    const [selectedOptionsEuPartner, setSelectedOptionsEuPartner] = useState([]);
    const [ftuPartnerModal, setFtuPartnerModal] = useState(false)
    const [euPartnerModal, setEuPartnerModal] = useState(false)

    const [ftuResourceListData, setFtuResourceListData] = useState([])
    const [EuResourceListData, setEuResourceListData] = useState([])
    const [rawFtuResourceData, setRawFtuResourceData] = useState([])
    const [rawEuResourceData, setRawEuResourceData] = useState([])
    const [selectedOptionsFtuResource, setSelectedOptionsFtuResource] = useState([]);
    const [selectedOptionsEuResource, setSelectedOptionsEuResource] = useState([]);
    const [ftuResourceModal, setFtuResourceModal] = useState(false)
    const [euResourceModal, setEuResourceModal] = useState(false)

    const [ftuProgramListData, setFtuProgramListData] = useState([])
    const [EuProgramListData, setEuProgramListData] = useState([])
    const [rawFtuProgramData, setRawFtuProgramData] = useState([])
    const [rawEuProgramData, setRawEuProgramData] = useState([])
    const [selectedOptionsFtuProgram, setSelectedOptionsFtuProgram] = useState([]);
    const [selectedOptionsEuProgram, setSelectedOptionsEuProgram] = useState([]);
    const [ftuProgramModal, setFtuProgramModal] = useState(false)
    const [euProgramModal, setEuProgramModal] = useState(false)

    const [partnerTableData, setPartnerTableData] = useState([])
    const [programTableData, setProgramTableData] = useState([])

    const [selectedOptions, setSelectedOptions] = useState([]);
    const partnerListUpdated = []

    const [selectedOptionsProgram, setSelectedOptionsProgram] = useState([])
    const programListUpdated = []

    const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
    const sourceListUpdated = []

    const [selectedOptionsMedium, setSelectedOptionsMedium] = useState([]);
    const mediumListUpdated = []

    const [selectedOptionsSourceEu, setSelectedOptionsSourceEu] = useState([]);

    const [selectedOptionsMediumEu, setSelectedOptionsMediumEu] = useState([]);


    const [isPartnerData, setIsPartnerData] = useState(false)
    const [isProgramData, setIsProgramData] = useState(false)

    // Source and Medium Model

    const [sourceModel, setSourceModel] = useState(false)
    const [sourceModelEu, setSourceModelEu] = useState(false)

    const [selectedOptionsMergedPartner, setSelectedOptionsMergedPartner] = useState([]);
    const [selectedOptionsMergedProgram, setSelectedOptionsMergedProgram] = useState([]);
    const [selectedOptionsMergedResource, setSelectedOptionsMergedResource] = useState([]);
    const [selectedOptionsMergedPartnerResource, setSelectedOptionsMergedPartnerResource] = useState([]);
    const [selectedOptionsMergedPartnerResourceEu, setSelectedOptionsMergedPartnerResourceEu] = useState([]);
    const [selectedOptionsMergedProgramResource, setSelectedOptionsMergedProgramResource] = useState([]);
    const [selectedOptionsMergedProgramResourceEu, setSelectedOptionsMergedProgramResourceEu] = useState([]);
    const [selectedOptionsMergedSourceMedium, setSelectedOptionsMergedSourceMedium] = useState([]);
    const [selectedOptionsMergedSourceMediumEu, setSelectedOptionsMergedSourceMediumEu] = useState([]);

    const [isProgramManagerDashboard, setIsProgramManagerDashboard] = useState(false)

    const [isFirstUsertableLoading, setIsFirstTableUserLoading] = useState(true);
    const [isSecondUserLoading, setIsSecondUserLoading] = useState(false);

    // Dream Big new states
    const [totalResourceConsumedByUser, setTotalResourceConsumedByUser] = useState([])
     const [totalResourceConsumedByUserBefore4thApril, setTotalResourceConsumedByUserBefore4thApril] = useState([])
    const [topResources, setTopResources] = useState([])
    const [topSourcesBasedOnEntryPoint, setTopSourcesBasedOnEntryPoint] = useState([])
    const [ftuVehicleQuestionCount, setFtuVehicleQuestionCount] = useState([])
    const [ftuDeviceCount, setFtuDeviceCount] = useState([])
    const [isVehicleDeviceTypeFilterOpen, setIsVehicleDeviceTypeFilterOpen] = useState(false);
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [vehicleDeviceCombination, setVehicleDeviceCombination] = useState([]);
    const [vehicleDeviceCombinationFilterData, setVehicleDeviceCombinationFilterData] = useState([]);
    const [vehicleOptions, setVehicleOptions] = useState([])
    const [deviceOptions, setDeviceOptions] = useState([])
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [isVehicleDeviceLoading, setIsVehicleDeviceLoading] = useState(false);

    const [selectedOptionsVehicleType, setSelectedOptionsVehicleType] = useState([]);
    const [selectedOptionsDeviceType, setSelectedOptionsDeviceType] = useState([]);
    const clearRef = useRef();
    const searchRef = useRef();

    const handleVehicleDeviceFilterOpen = () => {
        setIsVehicleDeviceTypeFilterOpen(!isVehicleDeviceTypeFilterOpen)
    }

    const onVehicleChange = (option) => {
        if (option) {
            setSelectedVehicle(option);
            // setFilterKeysAndValues({ ...filterKeysAndValues, sResourceID: option.value })
        } else {
            setSelectedVehicle(null);
            // const { sResourceID, ...rest } = filterKeysAndValues;
            // setFilterKeysAndValues(rest);
        }
    }

    const onDeviceChange = (option) => {
        if (option) {
            setSelectedDevice(option);
            // setFilterKeysAndValues({ ...filterKeysAndValues, sResourceID: option.value })
        } else {
            setSelectedDevice(null);
            // const { sResourceID, ...rest } = filterKeysAndValues;
            // setFilterKeysAndValues(rest);
        }
    }

    // multiselct vehicle function
    const handleMultipleVehicleSelect = (selected) => {
        setSelectedOptionsVehicleType(selected)
    }

    const handleMultipleDeviceSelect = (selected) => {
        setSelectedOptionsDeviceType(selected)
    }

    const handleVehicleDeviceCombinationSearch = async () => {
        // console.log(handleVehicleDeviceCombinationSearch, ">>>handleVehicleDeviceCombinationSearch clicked")
        // setIsVehicleDeviceLoading(true)
        // setIsVehicleDeviceTypeFilterOpen(false);

        // console.log(selectedVehicle, ">>>selectedVehicle")
        // console.log(selectedDevice, ">>>selectedDevice")
        // try {
        //     setIsFilterActive(true);

        //     const filterParameters = {};

        //     if (selectedVehicle?.value) {
        //         filterParameters.vehicle = selectedVehicle.value;
        //     }
        //     if (selectedDevice?.value) {
        //         filterParameters.device = selectedDevice.value;
        //     }
        //     const { data } = await api.getDreamBigVehicleDeviceCombinationCount(filterParameters);
        //     if (data) {
        //         setVehicleDeviceCombinationFilterData(data);
        //     } else {
        //         toast("No data found", {
        //             autoClose: 5000,
        //             type: toast.TYPE.ERROR,
        //         });
        //     }
        // } catch (error) {
        //     const detail = error?.response?.data?.detail;
        //     const message = error?.response?.data?.message;
        //     if (detail && detail !== "Authentication credentials were not provided.") {
        //         toast(String(detail), { autoClose: 5000, type: toast.TYPE.ERROR });
        //     } else if (message) {
        //         toast(String(message), { autoClose: 5000, type: toast.TYPE.ERROR });
        //     }
        // } finally {
        //     setIsVehicleDeviceLoading(false)
        // }

        // multiselect
        console.log(selectedOptionsVehicleType, ">>>>>selectedOptionsVehicleType");
        console.log(selectedOptionsDeviceType, ">>>>>selectedOptionsDeviceType");

        setIsVehicleDeviceLoading(true)
        setIsVehicleDeviceTypeFilterOpen(false);

        try {
            setIsFilterActive(true);

            const filterParameters = {};

            if (selectedOptionsVehicleType.length > 0) {
                filterParameters.vehicle = selectedOptionsVehicleType.map(opt => opt.value);
            }
            if (selectedOptionsDeviceType.length > 0) {
                filterParameters.device = selectedOptionsDeviceType.map(opt => opt.value);
            }

            console.log(filterParameters, ">>>>>filterParameters");

            const { data } = await api.getDreamBigVehicleDeviceCombinationCount(filterParameters);
            if (data) {
                let formattedData = data.map((obj) => {
                    if (!obj.vehicle) {
                        obj.vehicle = "Not Provided"
                    }

                    if (!obj.device) {
                        obj.device = "Not Provided"
                    }

                    return obj;
                })

                let sortedFormattedData = formattedData.sort((a, b) => {
                    const vehicleA = a.vehicle?.toLowerCase() || "";
                    const vehicleB = b.vehicle?.toLowerCase() || "";
                    return vehicleA.localeCompare(vehicleB);
                })

                setVehicleDeviceCombinationFilterData(sortedFormattedData);
            } else {
                toast("No data found", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        } catch (error) {
            const detail = error?.response?.data?.detail;
            const message = error?.response?.data?.message;
            if (detail && detail !== "Authentication credentials were not provided.") {
                toast(String(detail), { autoClose: 5000, type: toast.TYPE.ERROR });
            } else if (message) {
                toast(String(message), { autoClose: 5000, type: toast.TYPE.ERROR });
            }
        } finally {
            setIsVehicleDeviceLoading(false)
        }

    }

    const handleClearVehicleDeviceFilter = () => {
        setSelectedVehicle(null);
        setSelectedDevice(null);
        setIsFilterActive(false);
        setIsVehicleDeviceTypeFilterOpen(false)
        setVehicleDeviceCombinationFilterData([])
        setSelectedOptionsVehicleType([]);
        setSelectedOptionsDeviceType([])

    }

    const [selectedOptionsTopResources, setSelectedOptionsTopResources] = useState([]);
    const [selectedOptionsTopEntryPoint, setSelectedOptionsTopEntryPoint] = useState([]);

    // Dream Big All Filter tabke work
    const [firstDreamBigAllFilterData, setFirstDreamBigAllFilterData] = useState([])
    const [engagedDreamBigAllFilterData, setEngagedDreamBigAllFilterData] = useState([])
    const [firstAndEngagedCombineData, setFirstAndEngagedCombineData] = useState([]);
    const [allFilterOptions, setAllFilterOptions] = useState([]);
    const [openAllFilterSearchModal, setOpenAllFilterSearchModal] = useState(false);

    // below function and state for all filter model
    const [openAllFilterModel, setOpenAllFilterModel] = useState(false); // state to open new filter modal
    const handleOpen = () => setOpenAllFilterModel(true);
    const handleClose = () => setOpenAllFilterModel(false);

    //======== For first multiselect =================//
    const [oppTitleNameList, setOppTitleNameList] = useState(
        [
            {
                label: "sResourceID",
                value: "sResourceID"
            },
            {
                label: "sResourceType",
                value: "sResourceType"
            },
            {
                label: "sResourceDisplayName",
                value: "sResourceDisplayName"
            },
            {
                label: "sSource",
                value: "sSource"
            },
            // {
            //     label: "sMedium",
            //     value: "sMedium"
            // },
            {
                label: "sBusinessTurnover",
                value: "sBusinessTurnover"
            },
            {
                label: "sProgramManager",
                value: "sProgramManager"
            },
            {
                label: "vehicle_type",
                value: "vehicle_type"
            },
            {
                label: "device_type",
                value: "device_type"
            },
            {
                label: "sEntryPoint",
                value: "sEntryPoint"
            }
        ]
    ) // Filter Option type
    const [selectedOppTitle, setSelectedOppTitle] = useState([]) // selected Options (in array object label value)
    const [selectedOppTitleVal, setSelectedOppTitleVal] = useState([]); // just array of selected val, used for disabling select option

    const [filterKeysAndValues, setFilterKeysAndValues] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // all category options
    const [allResourceIdOptions, setAllResourceIdOptions] = useState([]);
    const [allResourceTypeOptions, setAllResourceTypesOptions] = useState([]);
    const [allResourceDisplayNameOptions, setAllResourceDisplayNameOptions] = useState([]);
    const [allSourceOptions, setAllSourceOptions] = useState([]);
    const [allMediumOptions, setAllMediumOptions] = useState([]);
    const [allEntryPointOptions, setAllEntryPointOptions] = useState([]);
    const [allBusinessTurnOverOptions, setAllBusinessTurnOverOptions] = useState([]);
    const [allProgrammeManagerOptions, setAllProgrammeManagerOptions] = useState([]);
    const [allVehicleTypeOptions, setAllVehicleTypeOptions] = useState([]);
    const [allDeviceTypeOptions, setAllDeviceTypeOptions] = useState([]);

    // selected options
    const [selectedResourceId, setSelectedResourceId] = useState(null);
    const [selectedResourceType, setSelectedResourceType] = useState(null);
    const [selectedResourceDisplayName, setSelectedResourceDisplayName] = useState(null);
    const [selectedSource, setSelectedSource] = useState(null);
    const [selectedMedium, setSelectedMedium] = useState(null);
    const [selectedEntryPoint, setSelectedEntryPoint] = useState(null);
    const [selectedBusinessTurnOver, setSelectedBusinessTurnover] = useState(null);
    const [selectedProgrammeManager, setSelectedProgrammeManager] = useState(null);
    const [selectedVehicleType, setSelectedVehicleType] = useState(null);
    const [selectedDeviceType, setSelectedDeviceType] = useState(null);

    //  handle change options
    const onResourceIdChange = (option) => {
        if (option) {
            setSelectedResourceId(option);
            setFilterKeysAndValues({ ...filterKeysAndValues, sResourceID: option.value })
        } else {
            setSelectedResourceId(null);
            const { sResourceID, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onResourceTypeChange = (option) => {
        if (option) {
            setSelectedResourceType(option);
            setFilterKeysAndValues({ ...filterKeysAndValues, sResourceType: option.value })
        } else {
            setSelectedResourceType(null);
            const { sResourceType, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onResourceDisplayNameChange = (option) => {
        if (option) {
            setSelectedResourceDisplayName(option);
            setFilterKeysAndValues({ ...filterKeysAndValues, sResourceDisplayName: option.value })
        } else {
            setSelectedResourceDisplayName(null);
            const { sResourceDisplayName, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onSourceChange = (option) => {
        if (option) {
            setSelectedSource(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, sSource: option.value })
        } else {
            setSelectedSource(null);
            const { sSource, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onMediumChange = (option) => {
        if (option) {
            setSelectedMedium(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, sMedium: option.value })
        } else {
            setSelectedMedium(null);
            const { sMedium, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onEntryPointChange = (option) => {
        if (option) {
            setSelectedEntryPoint(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, sEntryPoint: option.value })
        } else {
            setSelectedEntryPoint(null);
            const { sEntryPoint, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onBusinessTurnOverChange = (option) => {
        if (option) {
            setSelectedBusinessTurnover(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, sBusinessTurnover: option.value })
        } else {
            setSelectedBusinessTurnover(null);
            const { sBusinessTurnover, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onProgrammeManagerChange = (option) => {
        if (option) {
            setSelectedProgrammeManager(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, sProgramManager: option.value })

        } else {
            setSelectedProgrammeManager(null);
            const { sProgramManager, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onVehicleTypeChange = (option) => {
        if (option) {
            setSelectedVehicleType(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, vehicle_type: option.value })

        } else {
            setSelectedVehicleType(null);
            const { vehicle_type, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }
    }

    const onDeviceTypeChange = (option) => {
        console.log(option, ">>>onDeviceTypeChange Option")

        if (option) {
            setSelectedDeviceType(option)
            setFilterKeysAndValues({ ...filterKeysAndValues, device_type: option?.value })
        } else {
            setSelectedDeviceType(null);
            const { device_type, ...rest } = filterKeysAndValues;
            setFilterKeysAndValues(rest);
        }

    }



    const toggleAllOppTitle = () => {
        if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
            let temp = []

            if (selectedOppTitle.includes({ label: "All", value: "*" })) {
                console.log(">>>>entered if of toggleAllOppTitle")
                temp = selectedOppTitle
            } else {
                console.log(">>>>entered else of toggleAllOppTitle")
                temp = [{ label: "All", value: '*' }]
            }

            let tempSR = oppTitleNameList.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e)
                }
                return e
            })
            setOppTitleNameList(tempSR)
            setSelectedOppTitle(temp)
            //   getTagsDropdown(processFilters(temp))
        } else {
            setSelectedOppTitle([]);
            setSelectedDeviceType(null);
            setSelectedVehicleType(null);
            setSelectedResourceId(null);
            setSelectedResourceType(null);
            setSelectedResourceDisplayName(null);
            setSelectedSource(null);
            setSelectedMedium(null);
            setSelectedEntryPoint(null);
            setSelectedBusinessTurnover(null);
            setSelectedProgrammeManager(null);
            //   getTagsDropdown(null)
        }
    }

    const onOppTitleChange = (options) => {
        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            console.log(">>>>entered if of onOppTitleChange")
            setSelectedOppTitle([{ value: "*", label: "All" }]);
            // getTagsDropdown(processFilters(options))
        } else {
            console.log(">>>>entered else of onOppTitleChange")
            setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
            // getTagsDropdown(processFilters(options))
        }
    }

    const handleClearAll = () => {
        setSelectedOppTitle([]);
        setSelectedOppTitleVal([]);
        setSelectedResourceId(null);
        setSelectedResourceType(null);
        setSelectedResourceDisplayName(null);
        setSelectedSource(null);
        setSelectedMedium(null);
        setSelectedEntryPoint(null);
        setSelectedBusinessTurnover(null);
        setSelectedProgrammeManager(null);
        setSelectedVehicleType(null);
        setSelectedDeviceType(null);
        setFilterKeysAndValues({})
    }

    const handleAllFilterSearch = () => {
        console.log(filterKeysAndValues, ">>>>filterKeysAndValues")
        getTableData();
        setOpenAllFilterModel(false);
    }

    //////////////////// First multiselect over ///////////////////////

    //============= For second multiselect =================//



    /////////////////////// Second Multi Select (mukltiselct use nahi kar rhe abhi) /////////////



    /////////////////////////////////////////////////////////////////////////
    // when any filter category is selected
    useEffect(() => {
        let copyAllSelectedOppTitle = [...selectedOppTitle];
        let allSelectedOppTitleVals = [];
        if (copyAllSelectedOppTitle.length > 0) {
            allSelectedOppTitleVals = copyAllSelectedOppTitle.map((obj) => {
                const { value } = obj;
                return value;
            })
        }

        setSelectedOppTitleVal(allSelectedOppTitleVals)
    }, [selectedOppTitle])






    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    // const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsSearch, setSelectedOptionsSearch] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);

    const handleSearchByClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSelectSearch = (option) => {
        const newSelection = setSelectedOptionsSearch.includes(option)
            ? setSelectedOptionsSearch.filter((item) => item !== option)
            : [...setSelectedOptionsSearch, option];
        setSelectedOptions(newSelection);
    };

    const handleSearch = () => {
        console.log("Search By:", setSelectedOptionsSearch);
        console.log("Search Value:", searchValue);
        // Do your search logic here
    };


    const handleOpenAllFilterSearchModal = () => {
        setOpenAllFilterSearchModal(true);
    }

    const toggleOpenAllFilterSearchModal = () => {
        setOpenAllFilterSearchModal(!openAllFilterSearchModal)
    }




    //////////////////////////////////////////////////////////////////////


    const goToProgramManagerDashboard = () => {
        setIsProgramManagerDashboard(!isProgramManagerDashboard)
    }

    const handleSelect = (selected) => {
        setSelectedOptions(selected);
    };

    const handleSelectSource = (selected) => {
        setSelectedOptionsSource(selected)
    }

    useEffect(() => {
        if (selectedOptionsSource.length > 0) {
            const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
            console.log("Filt Data", filteredData);
            let arr1 = []
            filteredData.map((ele) => {
                if (ele.medium_name != "" && ele.medium_name != null) {
                    arr1.push(ele.medium_name)
                }
            });
            setMediumListData(arr1);
        } else {
            const mediumNames = rawSourceMediumData.reduce((uniqueNames, row) => {
                if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
                    uniqueNames.push(row.medium_name);
                }
                return uniqueNames;
            }, []);
            setMediumListData(mediumNames)
        }
    }, [selectedOptionsSource, rawSourceMediumData]);

    const handleSelectMedium = (selected) => {
        setSelectedOptionsMedium(selected)
    }

    useEffect(() => {
        if (selectedOptionsMedium.length > 0) {
            const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
            console.log("Filt Data", filteredData1);
            let arr2 = []
            filteredData1.map((ele) => {
                if (ele.sourse_name != "" && ele.sourse_name != null) {
                    arr2.push(ele.sourse_name)
                }
            });
            setSourceListData(arr2);
        } else {
            const sourceNames = rawSourceMediumData.reduce((uniqueNames, row) => {
                if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
                    uniqueNames.push(row.sourse_name);
                }
                return uniqueNames;
            }, []);
            setSourceListData(sourceNames)
        }
    }, [selectedOptionsMedium, rawSourceMediumData]);

    const handleSelectSourceEu = (selected) => {
        setSelectedOptionsSourceEu(selected)
    }

    useEffect(() => {
        if (selectedOptionsSourceEu.length > 0) {
            const filteredData = rawSourceMediumDataEu.filter(obj => selectedOptionsSourceEu.some(item => item.value === obj.sourse_name));
            console.log("Filt Data", filteredData);
            let arr3 = []
            filteredData.map((ele) => {
                if (ele.medium_name != "" && ele.medium_name != null) {
                    arr3.push(ele.medium_name)
                }
            });
            setMediumListDataEu(arr3);
        } else {
            const mediumNames = rawSourceMediumDataEu.reduce((uniqueNames, row) => {
                if (row.medium_name && (row.medium_name != null && row.medium_name != "") && !uniqueNames.includes(row.medium_name)) {
                    uniqueNames.push(row.medium_name);
                }
                return uniqueNames;
            }, []);
            setMediumListDataEu(mediumNames)
        }
    }, [selectedOptionsSourceEu, rawSourceMediumDataEu]);

    const handleSelectMediumEu = (selected) => {
        setSelectedOptionsMediumEu(selected)
    }

    useEffect(() => {
        if (selectedOptionsMediumEu.length > 0) {
            const filteredData1 = rawSourceMediumDataEu.filter(obj => selectedOptionsMediumEu.some(item => item.value === obj.medium_name));
            console.log("Filt Data", filteredData1);
            let arr2 = []
            filteredData1.map((ele) => {
                if (ele.sourse_name != "" && ele.sourse_name != null) {
                    arr2.push(ele.sourse_name)
                }
            });
            setSourceListDataEu(arr2);
        } else {
            const sourceNames = rawSourceMediumDataEu.reduce((uniqueNames, row) => {
                if (row.sourse_name && (row.sourse_name != null && row.sourse_name != "") && !uniqueNames.includes(row.sourse_name)) {
                    uniqueNames.push(row.sourse_name);
                }
                return uniqueNames;
            }, []);
            setSourceListDataEu(sourceNames)
        }
    }, [selectedOptionsMediumEu, rawSourceMediumDataEu]);

    const handleSelectProgram = (selected) => {
        setSelectedOptionsProgram(selected);
    };

    const handleFtuPartnerSelect = (selected) => {
        setSelectedOptionsFtuPartner(selected)
    }

    const handleEuPartnerSelect = (selected) => {
        setSelectedOptionsEuPartner(selected)
    }

    const handleFtuResourceSelect = (selected) => {
        setSelectedOptionsFtuResource(selected)
    }

    const handleEuResourceSelect = (selected) => {
        setSelectedOptionsEuResource(selected)
    }

    const handleFtuProgramSelect = (selected) => {
        setSelectedOptionsFtuProgram(selected)
    }

    const handleEuProgramSelect = (selected) => {
        setSelectedOptionsEuProgram(selected)
    }

    const openFilterModalisTrue = () => {
        setNewModal(true)
    }

    const openFilterModalisFalse = () => {
        setNewModal(false)
    }

    const openSourceModalisTrue = () => {
        setSourceModel(true)
    }

    const openSourceModalisFalse = () => {
        setSourceModel(false)
    }

    const openSourceModalisTrueEu = () => {
        setSourceModelEu(true)
    }

    const openSourceModalisFalseEu = () => {
        setSourceModelEu(false)
    }

    const openFtuPartnerModalisTrue = () => {
        setFtuPartnerModal(true)
    }

    const openFtuPartnerModalisFalse = () => {
        setFtuPartnerModal(false)
    }

    const openEuPartnerModalisTrue = () => {
        setEuPartnerModal(true)
    }

    const openEuPartnerModalisFalse = () => {
        setEuPartnerModal(false)
    }

    const openFtuResourceModalisTrue = () => {
        setFtuResourceModal(true)
    }

    const openFtuResourceModalisFalse = () => {
        setFtuResourceModal(false)
    }

    const openEuResourceModalisTrue = () => {
        setEuResourceModal(true)
    }

    const openEuResourceModalisFalse = () => {
        setEuResourceModal(false)
    }

    const openFtuProgramModalisTrue = () => {
        setFtuProgramModal(true)
    }

    const openFtuProgramModalisFalse = () => {
        setFtuProgramModal(false)
    }

    const openEuProgramModalisTrue = () => {
        setEuProgramModal(true)
    }

    const openEuProgramModalisFalse = () => {
        setEuProgramModal(false)
    }

    // useEffect(() => {
    //     localStorage.setItem('fromDate', fromDate);
    //   }, [fromDate]);

    //   useEffect(() => {
    //     localStorage.setItem('toDate', toDate);
    //   }, [toDate]);

    const ondatechange = (key, date) => {
        if (key === "fromDate") {
            setfromDate(date)

        } else if (key === "toDate") {
            settoDate(date)

        }
    };

    const dateAdjusted = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
                    toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const dateAdjusted1 = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                    toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const PartnerList = ["Whatsapp", "Facebook", "WEP", "Linkedin Marketing", "desh foundation", "GMBP", "EJM", "meetups", "Youtube"]

    const ProgramList = ["New - Social Champ 1 hour Workshop", "Coach connect", "Social Champ", "Go Digital", "Social Champ Package - Digital Marketing Genius", "BLRP Orientation", "Business Loan Sarathi Package", "Free Sales Program", "Google My Business Listing for Open Market"]

    const ProgramDataStructure = [
        {
            programName: "New Program",
            partnerData: [
                {
                    resourceName: null,
                    count: 900,
                    count2: 800
                },
                {
                    resourceName: "Facebook",
                    count: 700,
                    count2: 800
                },
                {
                    resourceName: "Instagram",
                    count: 500,
                    count2: 800
                },
            ]
        },
        {
            programName: "Old Program",
            partnerData: [
                {
                    resourceName: "Whatsapp",
                    count: 100,
                    count2: 800
                },
                {
                    resourceName: "Facebook",
                    count: 200,
                    count2: 800
                },
                {
                    resourceName: null,
                    count: 400,
                    count2: 800
                },
            ]
        },
        {
            programName: "Very Old Program",
            partnerData: [
                {
                    resourceName: "Linkedin",
                    count: 100,
                    count2: 800
                },
                {
                    resourceName: "Messanger",
                    count: 200,
                    count2: 800
                },
                {
                    resourceName: "WEP",
                    count: 400,
                    count2: 800
                },
            ]
        }
    ]

    const ProgramData1 = [
        {
            sPackageTitle: "Business Loan Sarathi Package",
            partnerData: [
                {
                    sEntryPoint: "",
                    engaged_services_count: 9,
                    first_time_services_count: 1
                }
            ]
        },
        {
            sPackageTitle: "Business Loan",
            partnerData: [
                {
                    sEntryPoint: "Whatsapp",
                    engaged_services_count: 8,
                    first_time_services_count: 5
                }
            ]
        }
    ]

    const arr = []
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [partnerDataProgramManager, setPartnerDataProgramManager] = useState([])
    const [resourceDataSelectedPartner, setResourceDataSelectedPartner] = useState([])
    const [selectedProgramManager, setSelectedProgramManager] = useState([])
    const [selectedPartnerName, setSelectedPartnerName] = useState('')
    const [selectedsEntryPoint, setSelectedsEntryPoint] = useState([]);
    const [entryPointList, setEntryPointList] = useState([]);
    const [pmData, setPmData] = useState([]);
    const [landingPageData, setLandingPageData] = useState([]);
    const [selectedEnties, setSelectedEnties] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState('');

    const [programDataManager, setProgramDataManager] = useState([])
    const [partnerDataForSelectedProgram, setPartnerDataForSelectedProgram] = useState([])
    const [selectedProgramName, setSelectedProgramName] = useState('')
    const [selectedResourceName, setSelectedResourceName] = useState([])
    const [isResourceTableLoading, setIsResourceTableLoading] = useState(false);



    const getEntryPoints = (ele) => {
        setSelectedPartner(ele.value);
        api.entryPointDataForProgramManagerDreamBigUser({
            sProgramManager: ele.value
        }).then((res) => {
            if (res) {
                const options = (res?.data || [])
                    .filter(item => item.sEntryPoint !== "" && item.sEntryPoint !== null)
                    .map(item => ({
                        label: item.sEntryPoint,
                        value: item.sEntryPoint
                    }));
                setEntryPointList(options);
            }
        })
    }

    const getFTCDataByPM = (ele) => {
        if (ele && ele.length > 0) {
            setSelectedEnties(ele)
            const valuesArray = ele.map(item => item.value);
            const requestPayload = {
                sProgramManager: selectedPartner,
                sEntryPoints: valuesArray,
            };
    
            if (fromDate && toDate) {
                const originalDate = new Date(toDate);
                originalDate.setUTCDate(originalDate.getUTCDate() + 1);
                const newDateStr = originalDate.toISOString();
                
                requestPayload.fromDate = dateAdjusted1(fromDate);
                requestPayload.toDate = dateAdjusted1(newDateStr);
            }
            api.getFTCDataByProgramManager(requestPayload).then((res) => {
                if (res) {
                    setPmData(res.data ? res.data : [])
                }
            })
        }
    }

    const getUserCountByResource = async (ele) => {
        try {
          if (!ele || ele.length === 0) return;
      
          const valuesArray = ele.map(item => item.value);
          console.log('valuesArray', valuesArray);
      
          const filterParameters = {};
          if (ele.length > 0) {
            filterParameters["sDreambigTitle"] = ele.map(opt => opt.value);
          }
      
          if (fromDate && toDate) {
            const originalDate = new Date(toDate);
            originalDate.setUTCDate(originalDate.getUTCDate() + 1);
            const newDateStr = originalDate.toISOString();
      
            filterParameters.fromDate = dateAdjusted1(fromDate);
            filterParameters.toDate = dateAdjusted1(newDateStr);
          }
      
          console.log('opt requestPayload', { sResourceDisplayName: valuesArray[0] });
      
          setIsResourceTableLoading(true);
      
          const res = await api.getUserCountsByResource(filterParameters);
          if (res) {
            setLandingPageData(res.data || []);
            console.log('getUserCountsByResource::', res);
          }
          if (res?.status === 301 || res?.status === 302) {
            console.warn("Redirect detected:", res.headers?.location);
            setLandingPageData([]);

            // toast.error("The data source has moved. Please contact support.");
            return;
          }
        } catch (error) {
            setLandingPageData([]);
          console.error("Error in getUserCountByResource:", error);
        } finally {
          setIsResourceTableLoading(false);
        }
      };

    const getProgramManagerData = (ele) => {
        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }

        // if(selectedProgramManager){
        //     filterParameters.sProgramManager = selectedProgramManager.value
        // }
        setPartnerDataProgramManager([])
        const { temppartnerDataForProgramManagerDreamBigUser } = api.partnerDataForProgramManagerDreamBigUser({ ...filterParameters, sProgramManager: ele.value })
            .then(({ data }) => {
                if (data.length > 0) {
                    console.log("Here", data)
                    setPartnerDataProgramManager(data)
                } else {
                    console.log("there", data)
                    setPartnerDataProgramManager([{
                        sEntryPoint: "No Data Available",
                        FTU_Count: 0,
                        EU_Count: 0
                    }])
                }

            })

    }

    const getProgramDataforManager = (ele) => {
        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        setProgramDataManager([])
        const { tempProgramDataForManagerDreamBigUser } = api.programDataForProgramManagerDreamBigUser({ ...filterParameters, sProgramManager: ele.value })
            .then(({ data }) => {
                if (data.length > 0) {
                    setProgramDataManager(data)
                } else {
                    setProgramDataManager([{
                        sPackageTitle: 'No Data Available',
                        FTU_Count: 0,
                        EU_Count: 0
                    }])
                }
                console.log("Program Main Data", data)

            })
    }

    const getResourceDataForSelectedPartner = (manager, partner) => {
        let filterParameters = {}
        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        setResourceDataSelectedPartner([])
        const { tempResourceDataForSelectedPartnerDreamBigUser } = api.resourceDataForSelectedPartnerDreamBigUser({ ...filterParameters, sProgramManager: manager, sEntryPoint: partner })
            .then(({ data }) => {
                console.log("Res Data", data)
                setResourceDataSelectedPartner(data)
            })
    }

    const getPartnerDataForSelectedProgram = (manager, program) => {
        let filterParameters = {}
        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }
        // setPartnerDataForSelectedProgram([])
        // const {tempPartnerDataForSelectedProgram} = api.partnerDataForSelectedPro({ ...filterParameters, sProgramManager: manager, sPackageTitle: program })
        // .then(({data}) => {
        //     setPartnerDataForSelectedProgram(data)
        // })
    }

    const getTableData = () => {
        let filterParameters = {}
        let allFilterTableFilters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }

        if (fromDate && toDate) {
            setIsDateSelected(true)
        } else {
            setIsDateSelected(false)
        }

        let ifHasAllFilterTableKeys = Object.keys(filterKeysAndValues);
        console.log(ifHasAllFilterTableKeys, ">>>>ifHasAllFilterTableKeys");

        if (selectedOppTitleVal.length > 0) {
            for (let elem of selectedOppTitleVal) {
                allFilterTableFilters[elem] = filterKeysAndValues[elem]
            }
        }

        // if (ifHasAllFilterTableKeys.length > 0) {
        //     for (let elem of ifHasAllFilterTableKeys) {
        //         allFilterTableFilters[elem] = filterKeysAndValues[elem]
        //     }
        // }


        console.log(filterParameters, ">>>>>filterParameters");
        console.log(programListUpdated, ">>>>>programListUpdated");


        if (programListUpdated.length != 0 && partnerListUpdated.length != 0) {

        } else if (programListUpdated.length != 0) {

        } else if (partnerListUpdated.length != 0) {

        } else {
            //Table Data API

            // Engaged Users Counts (FTU and EU)
            const { tempServices } = api.getengagedusercountDreamBig(filterParameters).then(({ data }) => {
                if (data) {
                    setCountData(data[0]);
                }
                else {
                    toast("", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }

            });


            // table-2 total resources consumed  by user before 4th April
            const { tempTotalResourceConsumedByUserBefore$thApril } = api.getDreamBigTotalResourcesConsumedByUserBefore4thApril(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        // setFirstTimePartnerResourceData(data)
                        console.log(data, ">>>>>totalResourceConsumedByUserData");

                        // const formatUserResourceRows = (backendData) => {
                        //     const rows = [];

                        //     backendData.forEach(user => {
                        //         // Main row for user
                        //         rows.push({
                        //             isUserRow: true,
                        //             userPhone: user.userPhone,
                        //             // resourcesConsumedBefore4April: user.resourcesConsumedBefore4April,
                        //             resourcesConsumedAfter4April: user.resourcesConsumed
                        //         });

                        //         // Rows for each resource
                        //         user.resources.forEach(resource => {
                        //             rows.push({
                        //                 isUserRow: false,
                        //                 userPhone: `${resource.sResourceDisplayName} (${resource.dtCreated})`,
                        //                 resourcesConsumedBefore4April: "",
                        //                 resourcesConsumedAfter4April: ""
                        //             });
                        //         });
                        //     });

                        //     return rows;
                        // };

                        // const formatted = formatUserResourceRows(data);
                        // console.log(formatted, ">>>>>formatted");
                        


                        setTotalResourceConsumedByUserBefore4thApril(data)

                        // setRawEuProgramData(data)
                        // const sourceNames = data.reduce((uniqueNames, row) => {
                        //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                        //       uniqueNames.push(row.resourse_name);
                        //     }
                        //     return uniqueNames;
                        //   }, []);
                        //   setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false);
                })

            // table-2 total resources consumed  by user after 4th April
            const { tempTotalResourceConsumedByUser } = api.getDreamBigTotalResourcesConsumedByUser(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        // setFirstTimePartnerResourceData(data)
                        console.log(data, ">>>>>totalResourceConsumedByUserData");

                        // const formatUserResourceRows = (backendData) => {
                        //     const rows = [];

                        //     backendData.forEach(user => {
                        //         // Main row for user
                        //         rows.push({
                        //             isUserRow: true,
                        //             userPhone: user.userPhone,
                        //             // resourcesConsumedBefore4April: user.resourcesConsumedBefore4April,
                        //             resourcesConsumedAfter4April: user.resourcesConsumed
                        //         });

                        //         // Rows for each resource
                        //         user.resources.forEach(resource => {
                        //             rows.push({
                        //                 isUserRow: false,
                        //                 userPhone: `${resource.sResourceDisplayName} (${resource.dtCreated})`,
                        //                 resourcesConsumedBefore4April: "",
                        //                 resourcesConsumedAfter4April: ""
                        //             });
                        //         });
                        //     });

                        //     return rows;
                        // };

                        // const formatted = formatUserResourceRows(data);
                        // console.log(formatted, ">>>>>formatted");
                        


                        setTotalResourceConsumedByUser(data)

                        // setRawEuProgramData(data)
                        // const sourceNames = data.reduce((uniqueNames, row) => {
                        //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                        //       uniqueNames.push(row.resourse_name);
                        //     }
                        //     return uniqueNames;
                        //   }, []);
                        //   setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false);
                })

            const { tempTopResources } = api.getDreamBigTopResources(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        // setFirstTimePartnerResourceData(data)
                        console.log(data, ">>>>TopResources");
                        setTopResources(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false);
                })

            const { tempTopSourcesBasedOnEntryPoint } = api.getDreamBigTopSourcesBasedOnEntryPoint(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        // setFirstTimePartnerResourceData(data)
                        console.log(data, ">>>>>TopResourcesBasedOnEntryPoint");

                        const handleEmptyField = data.map((obj) => {
                            let copyObj = { ...obj }

                            if (copyObj.Source_Id === "" || copyObj.Source_Id === null || copyObj.Source_Id === undefined) {
                                copyObj.Source_Id = "Not Provided"
                            }

                            return copyObj;
                        })

                        // setTopSourcesBasedOnEntryPoint(data)
                        setTopSourcesBasedOnEntryPoint(handleEmptyField)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false);
                })

            // const { tempFtuBasedOnVehicleQuestion } = api.getDreamBigFtuVehicleQuestion(filterParameters)
            //     .then(({ data }) => {
            //         if (data) {
            //             // setFirstTimePartnerResourceData(data)
            //             console.log(data, ">>>>>setFtuVehicleQuestionCount");

            //             let handlingEmptyField = data.map((obj) => {
            //                 let copyObj = { ...obj }

            //                 if (copyObj.vehicle === "" || copyObj.vehicle === null || copyObj.vehicle === undefined) {
            //                     copyObj.vehicle = "None"
            //                 } else if (copyObj.count === "" || copyObj.count === null || copyObj.count === undefined) {
            //                     copyObj.count = 0;
            //                 }

            //                 return copyObj;
            //             })

            //             // setFtuVehicleQuestionCount(data)
            //             setFtuVehicleQuestionCount(handlingEmptyField)
            //         } else {
            //             toast("", {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             })
            //         }
            //     }).catch((error) => {
            //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
            //             toast(String(error.response.data.detail), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         } else if (error.response.data.message) {
            //             toast(String(error.response.data.message), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         }
            //     }).finally(() => {
            //         setIsFirstTableUserLoading(false);
            //     })

            // const { tempDreamBigDeviceCount } = api.getDreamBigDeviceCount(filterParameters)
            //     .then(({ data }) => {
            //         if (data) {
            //             // setFirstTimePartnerResourceData(data)
            //             console.log(data, ">>>>>setFtuDeviceCount");

            //             const changeKeyNameCountForDevice = data.map((obj) => {
            //                 let newObj = { device: obj.device, deviceCount: obj.count }
            //                 return newObj
            //             })

            //             setFtuDeviceCount(changeKeyNameCountForDevice)
            //         } else {
            //             toast("", {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             })
            //         }
            //     }).catch((error) => {
            //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
            //             toast(String(error.response.data.detail), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         } else if (error.response.data.message) {
            //             toast(String(error.response.data.message), {
            //                 autoClose: 5000,
            //                 type: toast.TYPE.ERROR,
            //             });
            //         }
            //     }).finally(() => {
            //         setIsFirstTableUserLoading(false);
            //     })

            // vehicle  device count combination
            const { tempDreamBigVehicleDeviceCombinationCount } = api.getDreamBigVehicleDeviceCombinationCount(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        // setFirstTimePartnerResourceData(data)
                        console.log(data, ">>>>>setFtuDeviceVehicleCombinationCount");

                        const uniqueVehicle = {};
                        const uniqueDevice = {};

                        for (let elem of data) {
                            const vehicle = elem.vehicle ? elem.vehicle : "Not Provided";
                            const device = elem.device ? elem.device : "Not Provided";

                            if (uniqueVehicle[vehicle]) {
                                uniqueVehicle[vehicle]++;
                            } else {
                                uniqueVehicle[vehicle] = 1;
                            }

                            if (uniqueDevice[device]) {
                                uniqueDevice[device]++;
                            } else {
                                uniqueDevice[device] = 1;
                            }
                        }

                        let allUniqueVehicle = Object.keys(uniqueVehicle);
                        let allUniqueDevice = Object.keys(uniqueDevice);

                        console.log(allUniqueVehicle, ">>>>>allUniqueVehicle");
                        console.log(allUniqueDevice, ">>>>allUniqueDevice");



                        let formatedVehicleOption = allUniqueVehicle.map((val) => {
                            return {
                                label: val !== "Not Provided" ? val : "Not Provided",
                                value: val !== "Not Provided" ? val : null,
                            }
                        })

                        let formatedDeviceOption = allUniqueDevice.map((val) => {
                            return {
                                label: val !== "Not Provided" ? val : "Not Provided",
                                value: val !== "Not Provided" ? val : null,
                            }
                        })

                        let formattedData = data.map((obj) => {
                            if (!obj.vehicle) {
                                obj.vehicle = "Not Provided"
                            }

                            if (!obj.device) {
                                obj.device = "Not Provided"
                            }

                            return obj;
                        })

                        let sortedFormattedData = formattedData.sort((a, b) => {
                            const vehicleA = a.vehicle?.toLowerCase() || "";
                            const vehicleB = b.vehicle?.toLowerCase() || "";
                            return vehicleA.localeCompare(vehicleB);
                        })


                        setVehicleOptions(formatedVehicleOption);
                        setDeviceOptions(formatedDeviceOption);
                        setVehicleDeviceCombination(sortedFormattedData);
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false);
                })


            setIsFirstTableUserLoading(true);
            setIsSecondUserLoading(true)

            const { tempDreamBigServices5 } = api.getDreamBigFirstTimeAnnualTurnover(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setFirstTimeAnnualTurnoverData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsSecondUserLoading(false)
                })

            const { tempDreamBigServices6 } = api.getDreamBigEngagedAnnualTurnover(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        setEngagedAnnualTurnoverData(data)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsSecondUserLoading(false)
                })

            const { tempDreamBigFirstTimePartnerResource } = api.getDreamBigFirstTimePartnerResourceData(filterParameters)
                .then(({ data }) => {
                    if (data) {

                        console.log(data, ">>>>>setFirstTimePartnerResourceData");
                        // setFirstTimePartnerResourceData(data)

                        let handlingEmptyField = data.map((obj) => {
                            let copyObj = { ...obj }

                            if (copyObj.entrypoint_name === "" || copyObj.entrypoint_name === null || copyObj.entrypoint_name === undefined) {
                                copyObj.entrypoint_name = "Not Provided"
                            }

                            return copyObj;
                        })

                        setFirstTimePartnerResourceData(handlingEmptyField)

                        // setRawEuProgramData(data)
                        // const sourceNames = data.reduce((uniqueNames, row) => {
                        //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                        //       uniqueNames.push(row.resourse_name);
                        //     }
                        //     return uniqueNames;
                        //   }, []);
                        //   setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false);
                })

            const { tempDreamBigEngagedPartnerResource } = api.getDreamBigEngagedPartnerResourceData(filterParameters)
                .then(({ data }) => {
                    if (data) {
                        // setEngagedPartnerResourceData(data)

                        let handlingEmptyField = data.map((obj) => {
                            let copyObj = { ...obj }

                            if (copyObj.entrypoint_name === "" || copyObj.entrypoint_name === null || copyObj.entrypoint_name === undefined) {
                                copyObj.entrypoint_name = "Not Provided"
                            }

                            return copyObj;
                        })

                        setEngagedPartnerResourceData(handlingEmptyField)

                        // setRawEuProgramData(data)
                        // const sourceNames = data.reduce((uniqueNames, row) => {
                        //     if (row.resourse_name && (row.resourse_name != null && row.resourse_name != "") && !uniqueNames.includes(row.resourse_name)) {
                        //       uniqueNames.push(row.resourse_name);
                        //     }
                        //     return uniqueNames;
                        //   }, []);
                        //   setEuProgramListData(sourceNames)
                    } else {
                        toast("", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        })
                    }
                }).catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        toast(String(error.response.data.detail), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }).finally(() => {
                    setIsFirstTableUserLoading(false)
                })


            const fetchData = async () => {
                setIsLoading(true);
                try {
                    setIsFirstTableUserLoading(true);

                    const [firstFilterResponse, engagedFilterResponse] = await Promise.all([
                        api.getDreamBigFirstUserAllFiltertable(allFilterTableFilters),
                        api.getDreamBigEngagedUserAllFiltertable(allFilterTableFilters)
                    ]);

                    const firstFilterData = firstFilterResponse.data;
                    const engagedFilterData = engagedFilterResponse.data;

                    console.log(firstFilterData, ">>>>allFirstFilterTableData");
                    console.log(engagedFilterData, ">>>>allEngagedFilterTableData");

                    setFirstDreamBigAllFilterData(firstFilterData);
                    setEngagedDreamBigAllFilterData(engagedFilterData);

                    // Combining data and formatting for table
                    //////////////////////////////
                    let tableRowData = [];
                    /////////////////////////////

                    //////////////////// WORKING WITH FIRST USER DATA //////////////
                    const uniqueVehicleTypeFirstTime = {};
                    const uniqueDeviceTypeFirstTime = {};
                    const uniqueResourceIdFirstTime = {};
                    const uniqueResourceTypeFirstTime = {};
                    const uniqueResourceDisplayNameFirstTime = {};
                    const uniqueSourceFirstTime = {};
                    const uniqueMediumFirstTime = {};
                    const uniqueEntryPointFirstTime = {};
                    const uniqueBusinessTurnOverFirstTime = {};
                    const uniqueProgrammeManagerFirstTime = {};


                    for (let elem of firstFilterData) {
                        // unique device type
                        if (uniqueDeviceTypeFirstTime[elem["device_type"]]) {
                            uniqueDeviceTypeFirstTime[elem["device_type"]] = uniqueDeviceTypeFirstTime[elem["device_type"]] + 1
                        } else {
                            uniqueDeviceTypeFirstTime[elem["device_type"]] = 1;
                        }

                        // unique vehicle type
                        if (uniqueVehicleTypeFirstTime[elem["vehicle_type"]]) {
                            uniqueVehicleTypeFirstTime[elem["vehicle_type"]] = uniqueVehicleTypeFirstTime[elem["vehicle_type"]] + 1
                        } else {
                            uniqueVehicleTypeFirstTime[elem["vehicle_type"]] = 1;
                        }

                        // unique sResourceID
                        if (uniqueResourceIdFirstTime[elem["sResourceID"]]) {
                            uniqueResourceIdFirstTime[elem["sResourceID"]] = uniqueResourceIdFirstTime[elem["sResourceID"]] + 1
                        } else {
                            uniqueResourceIdFirstTime[elem["sResourceID"]] = 1;
                        }

                        // unique sResourceType
                        if (uniqueResourceTypeFirstTime[elem["sResourceType"]]) {
                            uniqueResourceTypeFirstTime[elem["sResourceType"]] = uniqueResourceTypeFirstTime[elem["sResourceType"]] + 1
                        } else {
                            uniqueResourceTypeFirstTime[elem["sResourceType"]] = 1;
                        }

                        // unique sResourceDisplayName
                        if (uniqueResourceDisplayNameFirstTime[elem["sResourceDisplayName"]]) {
                            uniqueResourceDisplayNameFirstTime[elem["sResourceDisplayName"]] = uniqueResourceDisplayNameFirstTime[elem["sResourceDisplayName"]] + 1
                        } else {
                            uniqueResourceDisplayNameFirstTime[elem["sResourceDisplayName"]] = 1;
                        }

                        // unique sSource
                        if (uniqueSourceFirstTime[elem["sSource"]]) {
                            uniqueSourceFirstTime[elem["sSource"]] = uniqueSourceFirstTime[elem["sSource"]] + 1
                        } else {
                            uniqueSourceFirstTime[elem["sSource"]] = 1;
                        }

                        // unique sMedium
                        if (uniqueMediumFirstTime[elem["sMedium"]]) {
                            uniqueMediumFirstTime[elem["sMedium"]] = uniqueMediumFirstTime[elem["sMedium"]] + 1
                        } else {
                            uniqueMediumFirstTime[elem["sMedium"]] = 1;
                        }

                        // unique sEntryPoint
                        if (uniqueEntryPointFirstTime[elem["sEntryPoint"]]) {
                            uniqueEntryPointFirstTime[elem["sEntryPoint"]] = uniqueEntryPointFirstTime[elem["sEntryPoint"]] + 1
                        } else {
                            uniqueEntryPointFirstTime[elem["sEntryPoint"]] = 1;
                        }

                        // unique sBusinessTurnover
                        if (uniqueBusinessTurnOverFirstTime[elem["sBusinessTurnover"]]) {
                            uniqueBusinessTurnOverFirstTime[elem["sBusinessTurnover"]] = uniqueBusinessTurnOverFirstTime[elem["sBusinessTurnover"]] + 1
                        } else {
                            uniqueBusinessTurnOverFirstTime[elem["sBusinessTurnover"]] = 1;
                        }

                        // unique sProgramManager
                        if (uniqueProgrammeManagerFirstTime[elem["sProgramManager"]]) {
                            uniqueProgrammeManagerFirstTime[elem["sProgramManager"]] = uniqueProgrammeManagerFirstTime[elem["sProgramManager"]] + 1
                        } else {
                            uniqueProgrammeManagerFirstTime[elem["sProgramManager"]] = 1;
                        }
                    }

                    // console.log(uniqueVehicleTypeFirstTime, ">>>uniqueVehicleTypeFirstTime");
                    // console.log(uniqueDeviceTypeFirstTime, ">>>uniqueDeviceTypeFirstTime");
                    // console.log(uniqueResourceIdFirstTime, ">>>>uniqueResourceIdFirstTime")
                    // console.log(uniqueResourceTypeFirstTime, ">>>uniqueResourceTypeFirstTime")
                    // console.log(uniqueResourceDisplayNameFirstTime, ">>>>uniqueResourceDisplayNameFirstTime")
                    // console.log(uniqueSourceFirstTime, ">>uniqueSourceFirstTime")
                    // console.log(uniqueMediumFirstTime, ">>>uniqueMediumFirstTime")
                    // console.log(uniqueEntryPointFirstTime, ">>uniqueEntryPointFirstTime")
                    // console.log(uniqueBusinessTurnOverFirstTime, ">>>uniqueBusinessTurnOverFirstTime")
                    // console.log(uniqueProgrammeManagerFirstTime, ">>>uniqueProgrammeManagerFirstTime")


                    /////////////////// WORKING WITH ENGAGED USER DATA ///////////////
                    const uniqueVehicleTypeEngaged = {};
                    const uniqueDeviceTypeEngaged = {};
                    const uniqueResourceIdEngaged = {};
                    const uniqueResourceTypeEngaged = {};
                    const uniqueResourceDisplayNameEngaged = {};
                    const uniqueSourceEngaged = {};
                    const uniqueMediumEngaged = {};
                    const uniqueEntryPointEngaged = {};
                    const uniqueBusinessTurnOverEngaged = {};
                    const uniqueProgrammeManagerEngaged = {};

                    for (let elem of engagedFilterData) {
                        // unique device type
                        if (uniqueDeviceTypeEngaged[elem["device_type"]]) {
                            uniqueDeviceTypeEngaged[elem["device_type"]] = uniqueDeviceTypeEngaged[elem["device_type"]] + 1
                        } else {
                            uniqueDeviceTypeEngaged[elem["device_type"]] = 1;
                        }

                        // unique vehicle type
                        if (uniqueVehicleTypeEngaged[elem["vehicle_type"]]) {
                            uniqueVehicleTypeEngaged[elem["vehicle_type"]] = uniqueVehicleTypeEngaged[elem["vehicle_type"]] + 1
                        } else {
                            uniqueVehicleTypeEngaged[elem["vehicle_type"]] = 1;
                        }

                        // unique sResourceID
                        if (uniqueResourceIdEngaged[elem["sResourceID"]]) {
                            uniqueResourceIdEngaged[elem["sResourceID"]] = uniqueResourceIdEngaged[elem["sResourceID"]] + 1
                        } else {
                            uniqueResourceIdEngaged[elem["sResourceID"]] = 1;
                        }

                        // unique sResourceType
                        if (uniqueResourceTypeEngaged[elem["sResourceType"]]) {
                            uniqueResourceTypeEngaged[elem["sResourceType"]] = uniqueResourceTypeEngaged[elem["sResourceType"]] + 1
                        } else {
                            uniqueResourceTypeEngaged[elem["sResourceType"]] = 1;
                        }

                        // unique sResourceDisplayName
                        if (uniqueResourceDisplayNameEngaged[elem["sResourceDisplayName"]]) {
                            uniqueResourceDisplayNameEngaged[elem["sResourceDisplayName"]] = uniqueResourceDisplayNameEngaged[elem["sResourceDisplayName"]] + 1
                        } else {
                            uniqueResourceDisplayNameEngaged[elem["sResourceDisplayName"]] = 1;
                        }

                        // unique sSource
                        if (uniqueSourceEngaged[elem["sSource"]]) {
                            uniqueSourceEngaged[elem["sSource"]] = uniqueSourceEngaged[elem["sSource"]] + 1
                        } else {
                            uniqueSourceEngaged[elem["sSource"]] = 1;
                        }

                        // unique sMedium
                        if (uniqueMediumEngaged[elem["sMedium"]]) {
                            uniqueMediumEngaged[elem["sMedium"]] = uniqueMediumEngaged[elem["sMedium"]] + 1
                        } else {
                            uniqueMediumEngaged[elem["sMedium"]] = 1;
                        }

                        // unique sEntryPoint
                        if (uniqueEntryPointEngaged[elem["sEntryPoint"]]) {
                            uniqueEntryPointEngaged[elem["sEntryPoint"]] = uniqueEntryPointEngaged[elem["sEntryPoint"]] + 1
                        } else {
                            uniqueEntryPointEngaged[elem["sEntryPoint"]] = 1;
                        }

                        // unique sBusinessTurnover
                        if (uniqueBusinessTurnOverEngaged[elem["sBusinessTurnover"]]) {
                            uniqueBusinessTurnOverEngaged[elem["sBusinessTurnover"]] = uniqueBusinessTurnOverEngaged[elem["sBusinessTurnover"]] + 1
                        } else {
                            uniqueBusinessTurnOverEngaged[elem["sBusinessTurnover"]] = 1;
                        }

                        // unique sProgramManager
                        if (uniqueProgrammeManagerEngaged[elem["sProgramManager"]]) {
                            uniqueProgrammeManagerEngaged[elem["sProgramManager"]] = uniqueProgrammeManagerEngaged[elem["sProgramManager"]] + 1
                        } else {
                            uniqueProgrammeManagerEngaged[elem["sProgramManager"]] = 1;
                        }
                    }

                    // console.log(uniqueVehicleTypeEngaged, ">>uniqueVehicleTypeEngaged");
                    // console.log(uniqueDeviceTypeEngaged,">>uniqueDeviceTypeEngaged");
                    // console.log(uniqueResourceIdEngaged, ">>uniqueResourceIdEngaged")
                    // console.log(uniqueResourceTypeEngaged,">>>uniqueResourceTypeEngaged")
                    // console.log(uniqueResourceDisplayNameEngaged,">>>uniqueResourceDisplayNameEngaged")
                    // console.log(uniqueSourceEngaged,">>>uniqueSourceEngaged")
                    // console.log(uniqueMediumEngaged,">>>uniqueMediumEngaged")
                    // console.log(uniqueEntryPointEngaged, ">>uniqueEntryPointEngaged")
                    // console.log(uniqueBusinessTurnOverEngaged,">>>uniqueBusinessTurnOverEngaged")
                    // console.log(uniqueProgrammeManagerEngaged, ">>>uniqueProgrammeManagerEngaged")

                    /////////// Extracting all keys from first time and engaged //////
                    // all keys first
                    let allKeysInFirstVehicle = Object.keys(uniqueVehicleTypeFirstTime)
                    let allKeysInFirstDevice = Object.keys(uniqueDeviceTypeFirstTime)
                    let allKeysInFirstResourceId = Object.keys(uniqueResourceIdFirstTime)
                    let allKeysInFirstResourceType = Object.keys(uniqueResourceTypeFirstTime)
                    let allKeysInFirstResourceDisplayName = Object.keys(uniqueResourceDisplayNameFirstTime);
                    let allKeysInFirstSource = Object.keys(uniqueSourceFirstTime)
                    let allKeysInFirstMedium = Object.keys(uniqueMediumFirstTime)
                    let allKeysInFirstEntryPoint = Object.keys(uniqueEntryPointFirstTime)
                    let allKeysInFirstBusinessTurnover = Object.keys(uniqueBusinessTurnOverFirstTime)
                    let allKeysInFirstProgrammeManager = Object.keys(uniqueProgrammeManagerFirstTime)

                    // all keys engaged
                    let allKeysInEngagedVehicle = Object.keys(uniqueVehicleTypeEngaged);
                    let allKeysInEngagedDevice = Object.keys(uniqueDeviceTypeEngaged);
                    let allKeysInEngagedResourceId = Object.keys(uniqueResourceIdEngaged)
                    let allKeysInEngagedResourceType = Object.keys(uniqueResourceTypeEngaged)
                    let allKeysInEngagedResourceDisplayName = Object.keys(uniqueResourceDisplayNameEngaged);
                    let allKeysInEngagedSource = Object.keys(uniqueSourceEngaged)
                    let allKeysInEngagedMedium = Object.keys(uniqueMediumEngaged)
                    let allKeysInEngagedEntryPoint = Object.keys(uniqueEntryPointEngaged)
                    let allKeysInEngagedBusinessTurnover = Object.keys(uniqueBusinessTurnOverEngaged)
                    let allKeysInEngagedProgrammeManager = Object.keys(uniqueProgrammeManagerFirstTime)


                    // console.log(allKeysInFirstVehicle, ">>allKeysInFirstVehicle")
                    // console.log(allKeysInEngagedVehicle, ">>>allKeysInEngagedVehicle");

                    // console.log(allKeysInFirstDevice, ">>allKeysInFirstDevice")
                    // console.log(allKeysInEngagedDevice, ">>>allKeysInEngagedDevice");
                    // console.log(allKeysInEngagedBusinessTurnover)


                    ////////// Combining keys first and engaged /////////////////
                    let allCombineVehicleType = [...allKeysInFirstVehicle, ...allKeysInEngagedVehicle];
                    let allCombineDeviceType = [...allKeysInFirstDevice, ...allKeysInEngagedDevice];
                    let allCombineResourceId = [...allKeysInFirstResourceId, ...allKeysInEngagedResourceId];
                    let allCombineResourceType = [...allKeysInFirstResourceType, ...allKeysInEngagedResourceType];
                    let allCombineResourceDisplayName = [...allKeysInFirstResourceDisplayName, ...allKeysInEngagedResourceDisplayName];
                    let allCombineSource = [...allKeysInFirstSource, ...allKeysInEngagedSource];
                    let allCombineMedium = [...allKeysInFirstMedium, ...allKeysInEngagedMedium];
                    let allCombineEntryPoint = [...allKeysInFirstEntryPoint, ...allKeysInEngagedEntryPoint];
                    let allCombineBusinessTurnOver = [...allKeysInFirstBusinessTurnover, ...allKeysInEngagedBusinessTurnover];
                    let allCombineProgrammeManager = [...allKeysInFirstProgrammeManager, ...allKeysInEngagedProgrammeManager];

                    // console.log(allCombineVehicleType, ">>allCombineVehicleType");
                    // console.log(allCombineDeviceType, ">>>>allCombineDeviceType");
                    // console.log(allCombineResourceId, ">>>>allCombineResourceId");
                    // console.log(allCombineResourceType, ">>>allCombineResourceType");
                    // console.log(allCombineResourceDisplayName, ">>allCombineResourceDisplayName");
                    // console.log(allCombineSource, ">>>allCombineSource");
                    // console.log(allCombineMedium, ">>>allCombineMedium");
                    // console.log(allCombineEntryPoint, ">>>>allCombineEntryPoint")
                    // console.log(allCombineBusinessTurnOver, ">>>>allCombineBusinessTurnOver");
                    // console.log(allCombineProgrammeManager, ">>>allCombineProgrammeManager")

                    //////////// removing dulicates from first and engaged combined //////////
                    let uniqueVehicleType = allCombineVehicleType.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let vehicleTypeOptions = uniqueVehicleType.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllVehicleTypeOptions(vehicleTypeOptions)

                    let uniqueDeviceType = allCombineDeviceType.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let deviceTypeOptions = uniqueDeviceType.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllDeviceTypeOptions(deviceTypeOptions)

                    let uniqueResourceId = allCombineResourceId.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let resourceIdOptions = uniqueResourceId.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllResourceIdOptions(resourceIdOptions)

                    let uniqueResourceType = allCombineResourceType.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let resourceTypeOptions = uniqueResourceType.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllResourceTypesOptions(resourceTypeOptions)

                    let uniqueResourceDisplayName = allCombineResourceDisplayName.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let resourceDisplayNameOptions = uniqueResourceDisplayName.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllResourceDisplayNameOptions(resourceDisplayNameOptions)

                    let uniqueSource = allCombineSource.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let sourceOptions = uniqueSource.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllSourceOptions(sourceOptions)

                    let uniqueMedium = allCombineMedium.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let mediumOptions = uniqueMedium.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllMediumOptions(mediumOptions)


                    let uniqueEntryPoint = allCombineEntryPoint.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let entryPointOptions = uniqueEntryPoint.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllEntryPointOptions(entryPointOptions)

                    let uniqueBusinessTurnOver = allCombineBusinessTurnOver.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let businessTurnoverOptions = uniqueBusinessTurnOver.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllBusinessTurnOverOptions(businessTurnoverOptions)

                    let uniqueProgrammeManager = allCombineProgrammeManager.reduce((acc, curr) => {
                        if (!acc.includes(curr)) {
                            acc.push(curr)
                        }

                        return acc;
                    }, [])
                    let programmeManagerOptions = uniqueProgrammeManager.map((val) => {
                        return {
                            label: val,
                            value: val,
                        }
                    })
                    // setAllProgrammeManagerOptions(programmeManagerOptions)

                    // console.log(uniqueVehicleType);
                    // console.log(uniqueDeviceType);
                    // console.log(uniqueResourceId);
                    // console.log(uniqueResourceType);
                    // console.log(uniqueResourceDisplayName)
                    // console.log(uniqueSource);
                    // console.log(uniqueMedium)
                    // console.log(uniqueEntryPoint);
                    // console.log(uniqueBusinessTurnOver);
                    // console.log(uniqueProgrammeManager);


                    // combining data- (working, but testing required)
                    // for (let elem of uniqueVehicleType) {
                    //     tableRowData.push(
                    //         {
                    //             countOf: `Vehicle: ${elem}`,
                    //             firstTimeUserCount: uniqueVehicleTypeFirstTime[elem],
                    //             engagedUserCount: uniqueVehicleTypeEngaged[elem],
                    //         })
                    // }

                    // Cnditionally oushing in tableRowData, if there is no filter, then all, if there is filter then check what filter it includes and push accordingly
                    if (ifHasAllFilterTableKeys.length > 0 && selectedOppTitleVal.length > 0) {
                        if (ifHasAllFilterTableKeys.includes("vehicle_type")) {
                            for (let i = 0; i < uniqueVehicleType.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Vehicle",
                                            rowSpan: uniqueVehicleType?.length,
                                            countOf: `${uniqueVehicleType[i]}`,
                                            firstTimeUserCount: uniqueVehicleTypeFirstTime[uniqueVehicleType[i]],
                                            engagedUserCount: uniqueVehicleTypeEngaged[uniqueVehicleType[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueVehicleType[i]}`,
                                            firstTimeUserCount: uniqueVehicleTypeFirstTime[uniqueVehicleType[i]],
                                            engagedUserCount: uniqueVehicleTypeEngaged[uniqueVehicleType[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("device_type")) {
                            for (let i = 0; i < uniqueDeviceType.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Device",
                                            rowSpan: uniqueDeviceType?.length,
                                            countOf: `${uniqueDeviceType[i]}`,
                                            firstTimeUserCount: uniqueDeviceTypeFirstTime[uniqueDeviceType[i]],
                                            engagedUserCount: uniqueDeviceTypeEngaged[uniqueDeviceType[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueDeviceType[i]}`,
                                            firstTimeUserCount: uniqueDeviceTypeFirstTime[uniqueDeviceType[i]],
                                            engagedUserCount: uniqueDeviceTypeEngaged[uniqueDeviceType[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sResourceID")) {
                            for (let i = 0; i < uniqueResourceId.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Resource-Id",
                                            rowSpan: uniqueResourceId?.length,
                                            countOf: `${uniqueResourceId[i]}`,
                                            firstTimeUserCount: uniqueResourceIdFirstTime[uniqueResourceId[i]],
                                            engagedUserCount: uniqueResourceIdEngaged[uniqueResourceId[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueResourceId[i]}`,
                                            firstTimeUserCount: uniqueResourceIdFirstTime[uniqueResourceId[i]],
                                            engagedUserCount: uniqueResourceIdEngaged[uniqueResourceId[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sResourceType")) {
                            for (let i = 0; i < uniqueResourceType.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Resource Type",
                                            rowSpan: uniqueResourceType?.length,
                                            countOf: `${uniqueResourceType[i]}`,
                                            firstTimeUserCount: uniqueResourceTypeFirstTime[uniqueResourceType[i]],
                                            engagedUserCount: uniqueResourceTypeEngaged[uniqueResourceType[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueResourceType[i]}`,
                                            firstTimeUserCount: uniqueResourceTypeFirstTime[uniqueResourceType[i]],
                                            engagedUserCount: uniqueResourceTypeEngaged[uniqueResourceType[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sResourceDisplayName")) {
                            for (let i = 0; i < uniqueResourceDisplayName.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Resource Display Name",
                                            rowSpan: uniqueResourceDisplayName?.length,
                                            countOf: `${uniqueResourceDisplayName[i]}`,
                                            firstTimeUserCount: uniqueResourceDisplayNameFirstTime[uniqueResourceDisplayName[i]],
                                            engagedUserCount: uniqueResourceDisplayNameEngaged[uniqueResourceDisplayName[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueResourceDisplayName[i]}`,
                                            firstTimeUserCount: uniqueResourceDisplayNameFirstTime[uniqueResourceDisplayName[i]],
                                            engagedUserCount: uniqueResourceDisplayNameEngaged[uniqueResourceDisplayName[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sSource")) {
                            for (let i = 0; i < uniqueSource.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Source",
                                            rowSpan: uniqueSource?.length,
                                            countOf: `${uniqueSource[i]}`,
                                            firstTimeUserCount: uniqueSourceFirstTime[uniqueSource[i]],
                                            engagedUserCount: uniqueSourceEngaged[uniqueSource[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueSource[i]}`,
                                            firstTimeUserCount: uniqueSourceFirstTime[uniqueSource[i]],
                                            engagedUserCount: uniqueSourceEngaged[uniqueSource[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sMedium")) {
                            for (let i = 0; i < uniqueMedium.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Medium",
                                            rowSpan: uniqueMedium?.length,
                                            countOf: `${uniqueMedium[i]}`,
                                            firstTimeUserCount: uniqueMediumFirstTime[uniqueMedium[i]],
                                            engagedUserCount: uniqueMediumEngaged[uniqueMedium[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueMedium[i]}`,
                                            firstTimeUserCount: uniqueMediumFirstTime[uniqueMedium[i]],
                                            engagedUserCount: uniqueMediumEngaged[uniqueMedium[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sEntryPoint")) {
                            for (let i = 0; i < uniqueEntryPoint.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Entry Point",
                                            rowSpan: uniqueEntryPoint?.length,
                                            countOf: `${uniqueEntryPoint[i]}`,
                                            firstTimeUserCount: uniqueEntryPointFirstTime[uniqueEntryPoint[i]],
                                            engagedUserCount: uniqueEntryPointEngaged[uniqueEntryPoint[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueEntryPoint[i]}`,
                                            firstTimeUserCount: uniqueEntryPointFirstTime[uniqueEntryPoint[i]],
                                            engagedUserCount: uniqueEntryPointEngaged[uniqueEntryPoint[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sBusinessTurnover")) {
                            for (let i = 0; i < uniqueBusinessTurnOver.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Business Turnover",
                                            rowSpan: uniqueBusinessTurnOver?.length,
                                            countOf: `${uniqueBusinessTurnOver[i]}`,
                                            firstTimeUserCount: uniqueBusinessTurnOverFirstTime[uniqueBusinessTurnOver[i]],
                                            engagedUserCount: uniqueBusinessTurnOverEngaged[uniqueBusinessTurnOver[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueBusinessTurnOver[i]}`,
                                            firstTimeUserCount: uniqueBusinessTurnOverFirstTime[uniqueBusinessTurnOver[i]],
                                            engagedUserCount: uniqueBusinessTurnOverEngaged[uniqueBusinessTurnOver[i]],
                                        })
                                }

                            }
                        }

                        if (ifHasAllFilterTableKeys.includes("sProgramManager")) {
                            for (let i = 0; i < uniqueProgrammeManager.length; i++) {
                                if (i == 0) {
                                    tableRowData.push(
                                        {
                                            category: "Programme manager",
                                            rowSpan: uniqueProgrammeManager?.length,
                                            countOf: `${uniqueProgrammeManager[i]}`,
                                            firstTimeUserCount: uniqueProgrammeManagerFirstTime[uniqueProgrammeManager[i]],
                                            engagedUserCount: uniqueProgrammeManagerEngaged[uniqueProgrammeManager[i]],
                                        })
                                } else {
                                    tableRowData.push(
                                        {
                                            countOf: `${uniqueProgrammeManager[i]}`,
                                            firstTimeUserCount: uniqueProgrammeManagerFirstTime[uniqueProgrammeManager[i]],
                                            engagedUserCount: uniqueProgrammeManagerEngaged[uniqueProgrammeManager[i]],
                                        })
                                }

                            }
                        }
                    } else {
                        // setting options for all categories-
                        setAllVehicleTypeOptions(vehicleTypeOptions)
                        setAllDeviceTypeOptions(deviceTypeOptions)
                        setAllResourceIdOptions(resourceIdOptions)
                        setAllResourceTypesOptions(resourceTypeOptions)
                        setAllResourceDisplayNameOptions(resourceDisplayNameOptions)
                        setAllSourceOptions(sourceOptions)
                        setAllMediumOptions(mediumOptions)
                        setAllEntryPointOptions(entryPointOptions)
                        setAllBusinessTurnOverOptions(businessTurnoverOptions)
                        setAllProgrammeManagerOptions(programmeManagerOptions)



                        //////////////////////////////////////
                        for (let i = 0; i < uniqueVehicleType.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Vehicle",
                                        rowSpan: uniqueVehicleType?.length,
                                        countOf: `${uniqueVehicleType[i]}`,
                                        firstTimeUserCount: uniqueVehicleTypeFirstTime[uniqueVehicleType[i]],
                                        engagedUserCount: uniqueVehicleTypeEngaged[uniqueVehicleType[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueVehicleType[i]}`,
                                        firstTimeUserCount: uniqueVehicleTypeFirstTime[uniqueVehicleType[i]],
                                        engagedUserCount: uniqueVehicleTypeEngaged[uniqueVehicleType[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueDeviceType.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Device",
                                        rowSpan: uniqueDeviceType?.length,
                                        countOf: `${uniqueDeviceType[i]}`,
                                        firstTimeUserCount: uniqueDeviceTypeFirstTime[uniqueDeviceType[i]],
                                        engagedUserCount: uniqueDeviceTypeEngaged[uniqueDeviceType[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueDeviceType[i]}`,
                                        firstTimeUserCount: uniqueDeviceTypeFirstTime[uniqueDeviceType[i]],
                                        engagedUserCount: uniqueDeviceTypeEngaged[uniqueDeviceType[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueResourceId.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Resource-Id",
                                        rowSpan: uniqueResourceId?.length,
                                        countOf: `${uniqueResourceId[i]}`,
                                        firstTimeUserCount: uniqueResourceIdFirstTime[uniqueResourceId[i]],
                                        engagedUserCount: uniqueResourceIdEngaged[uniqueResourceId[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueResourceId[i]}`,
                                        firstTimeUserCount: uniqueResourceIdFirstTime[uniqueResourceId[i]],
                                        engagedUserCount: uniqueResourceIdEngaged[uniqueResourceId[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueResourceType.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Resource Type",
                                        rowSpan: uniqueResourceType?.length,
                                        countOf: `${uniqueResourceType[i]}`,
                                        firstTimeUserCount: uniqueResourceTypeFirstTime[uniqueResourceType[i]],
                                        engagedUserCount: uniqueResourceTypeEngaged[uniqueResourceType[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueResourceType[i]}`,
                                        firstTimeUserCount: uniqueResourceTypeFirstTime[uniqueResourceType[i]],
                                        engagedUserCount: uniqueResourceTypeEngaged[uniqueResourceType[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueResourceDisplayName.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Resource Display Name",
                                        rowSpan: uniqueResourceDisplayName?.length,
                                        countOf: `${uniqueResourceDisplayName[i]}`,
                                        firstTimeUserCount: uniqueResourceDisplayNameFirstTime[uniqueResourceDisplayName[i]],
                                        engagedUserCount: uniqueResourceDisplayNameEngaged[uniqueResourceDisplayName[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueResourceDisplayName[i]}`,
                                        firstTimeUserCount: uniqueResourceDisplayNameFirstTime[uniqueResourceDisplayName[i]],
                                        engagedUserCount: uniqueResourceDisplayNameEngaged[uniqueResourceDisplayName[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueSource.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Source",
                                        rowSpan: uniqueSource?.length,
                                        countOf: `${uniqueSource[i]}`,
                                        firstTimeUserCount: uniqueSourceFirstTime[uniqueSource[i]],
                                        engagedUserCount: uniqueSourceEngaged[uniqueSource[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueSource[i]}`,
                                        firstTimeUserCount: uniqueSourceFirstTime[uniqueSource[i]],
                                        engagedUserCount: uniqueSourceEngaged[uniqueSource[i]],
                                    })
                            }

                        }

                        // // Medium and entrypoint are same things
                        // for (let i = 0; i < uniqueMedium.length; i++) {
                        //     if (i == 0) {
                        //         tableRowData.push(
                        //             {
                        //                 category: "Medium",
                        //                 rowSpan: uniqueMedium?.length,
                        //                 countOf: `${uniqueMedium[i]}`,
                        //                 firstTimeUserCount: uniqueMediumFirstTime[uniqueMedium[i]],
                        //                 engagedUserCount: uniqueMediumEngaged[uniqueMedium[i]],
                        //             })
                        //     } else {
                        //         tableRowData.push(
                        //             {
                        //                 countOf: `${uniqueMedium[i]}`,
                        //                 firstTimeUserCount: uniqueMediumFirstTime[uniqueMedium[i]],
                        //                 engagedUserCount: uniqueMediumEngaged[uniqueMedium[i]],
                        //             })
                        //     }

                        // }

                        for (let i = 0; i < uniqueEntryPoint.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Entry Point",
                                        rowSpan: uniqueEntryPoint?.length,
                                        countOf: `${uniqueEntryPoint[i]}`,
                                        firstTimeUserCount: uniqueEntryPointFirstTime[uniqueEntryPoint[i]],
                                        engagedUserCount: uniqueEntryPointEngaged[uniqueEntryPoint[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueEntryPoint[i]}`,
                                        firstTimeUserCount: uniqueEntryPointFirstTime[uniqueEntryPoint[i]],
                                        engagedUserCount: uniqueEntryPointEngaged[uniqueEntryPoint[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueBusinessTurnOver.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Business Turnover",
                                        rowSpan: uniqueBusinessTurnOver?.length,
                                        countOf: `${uniqueBusinessTurnOver[i]}`,
                                        firstTimeUserCount: uniqueBusinessTurnOverFirstTime[uniqueBusinessTurnOver[i]],
                                        engagedUserCount: uniqueBusinessTurnOverEngaged[uniqueBusinessTurnOver[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueBusinessTurnOver[i]}`,
                                        firstTimeUserCount: uniqueBusinessTurnOverFirstTime[uniqueBusinessTurnOver[i]],
                                        engagedUserCount: uniqueBusinessTurnOverEngaged[uniqueBusinessTurnOver[i]],
                                    })
                            }

                        }

                        for (let i = 0; i < uniqueProgrammeManager.length; i++) {
                            if (i == 0) {
                                tableRowData.push(
                                    {
                                        category: "Programme manager",
                                        rowSpan: uniqueProgrammeManager?.length,
                                        countOf: `${uniqueProgrammeManager[i]}`,
                                        firstTimeUserCount: uniqueProgrammeManagerFirstTime[uniqueProgrammeManager[i]],
                                        engagedUserCount: uniqueProgrammeManagerEngaged[uniqueProgrammeManager[i]],
                                    })
                            } else {
                                tableRowData.push(
                                    {
                                        countOf: `${uniqueProgrammeManager[i]}`,
                                        firstTimeUserCount: uniqueProgrammeManagerFirstTime[uniqueProgrammeManager[i]],
                                        engagedUserCount: uniqueProgrammeManagerEngaged[uniqueProgrammeManager[i]],
                                    })
                            }

                        }
                    }



                    console.log(tableRowData, ">>>>>>>>tableRowData");


                    // setting main table data
                    setFirstAndEngagedCombineData(tableRowData);

                    // all options
                    let allOptions = tableRowData.map((obj) => {
                        const { countOf } = obj;
                        return {
                            value: countOf,
                            label: countOf
                        }
                    })



                    setAllFilterOptions(allOptions);

                } catch (error) {
                    const errorMessage =
                        error.response?.data?.detail || error.response?.data?.message || "Something went wrong";

                    if (errorMessage !== "Authentication credentials were not provided.") {
                        toast(String(errorMessage), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    setIsLoading(false);
                } finally {
                    setIsFirstTableUserLoading(false);
                    setIsLoading(false);
                }
            };

            // function call getting allFIlter Table data
            fetchData();


        }
    }

    const EngagedPartnerResourceData = [{
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Business Performance Evaluation Tool",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 3
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 29
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "dePreneur Listing",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 18
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 4
    },
    {
        "entrypoint_name": "Amazon_Saheli",
        "resourcedisplay_name": "deAsra Business Listing",
        "resourse_count": 6
    },
    {
        "entrypoint_name": "Amazon_Saheli",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 5
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 10
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 83
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Funding Readiness Assessment Tool",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 74
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Blog View",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 7
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 20
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 16
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Social Media Marketing Checklist",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "deAsra Business Listing",
        "resourse_count": 17
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 4
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 4
    },
    {
        "entrypoint_name": "Ashwamedh Expo",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 3
    },
    {
        "entrypoint_name": "Ashwamedh_expo",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "AspireForHer",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "AspireForHer",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 16
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 16
    },
    {
        "entrypoint_name": "Atharva_Finance",
        "resourcedisplay_name": "Trademark Application Filing",
        "resourse_count": 1
    }]




    const FirstTimePartnerResourceData = [{
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 11
    },
    {
        "entrypoint_name": "3KM",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 24
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "ABBM_Nagpur",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Amazon_Saheli",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 3
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 88
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Funding Readiness Assessment Tool",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Amhi_Udyogini",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "Compare Options & Apply for MSME Business Loan",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 14
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Ankur_Incubation",
        "resourcedisplay_name": "FSSAI Registration",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Apple_salon",
        "resourcedisplay_name": "Funding proposal creation",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "AspireForHer",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Atharva_AccFin",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 15
    },
    {
        "entrypoint_name": "Atharva_Finance",
        "resourcedisplay_name": "Udyam Registration Checklist",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Baramati_Business_Group",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 43
    },
    {
        "entrypoint_name": "Baramati_Incubation",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Baramati_Incubation",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 13
    },
    {
        "entrypoint_name": "BBN",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 103
    },
    {
        "entrypoint_name": "BBNG",
        "resourcedisplay_name": "Events Registration",
        "resourse_count": 2
    },
    {
        "entrypoint_name": "BBNG",
        "resourcedisplay_name": "FSSAI License",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "BBN_Sangli",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "Bhadipa",
        "resourcedisplay_name": "Compare options & Apply for MSME Business Loan",
        "resourse_count": 19
    },
    {
        "entrypoint_name": "Bhadipa",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "deAsra Business Listing",
        "resourse_count": 26
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 9
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "dePreneur Listing",
        "resourse_count": 8
    },
    {
        "entrypoint_name": "BITO",
        "resourcedisplay_name": "Sign Up",
        "resourse_count": 1
    }]


    const firstTimeProgramResourceData1 = [{
        "packagetitle_name": "Taxation for MSME's",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 4
    },
    {
        "packagetitle_name": "Townsquare for J4E",
        "resourcedisplay_name": "Townsquare Service",
        "resourse_count": 10
    },
    {
        "packagetitle_name": "Understanding & Application of Finance in Business",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 9
    },
    {
        "packagetitle_name": "Understanding & Application of Finance in Business 26 May",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 33
    },
    {
        "packagetitle_name": "Understanding Government Schemes/Initiatives For MSMEs",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 144
    },
    {
        "packagetitle_name": "Understanding Govt. Schemes and Initiatives for MSME's",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 98
    },
    {
        "packagetitle_name": "Vrindavan_Banquet (3rd March 2023)",
        "resourcedisplay_name": "Group Experts Consultation",
        "resourse_count": 15
    },
    {
        "packagetitle_name": "WhatsApp for Business - 3rd June 2022",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 48
    },
    {
        "packagetitle_name": "WhatsApp for Business Training - Oct. 2022",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 19
    },
    {
        "packagetitle_name": "Xpert Consultation",
        "resourcedisplay_name": "deAsra Experts",
        "resourse_count": 8
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "deAsra Experts",
        "resourse_count": 4
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "Xpert Cliniq",
        "resourse_count": 26
    },
    {
        "packagetitle_name": "– All about Udyam Registration for your Business",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 3
    }
    ]

    const engagedProgramResourceData1 = [{
        "packagetitle_name": "Xpert Consultation",
        "resourcedisplay_name": "deAsra Experts",
        "resourse_count": 2
    },
    {
        "packagetitle_name": "Xpert Consultation",
        "resourcedisplay_name": "Expert Consult",
        "resourse_count": 10
    },
    {
        "packagetitle_name": "Xpert Consultation",
        "resourcedisplay_name": "Expert Consultation",
        "resourse_count": 14
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "Expert Consult",
        "resourse_count": 2
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "Expert Consultation",
        "resourse_count": 6
    },
    {
        "packagetitle_name": "Xpert Consultation Package",
        "resourcedisplay_name": "Xpert Cliniq",
        "resourse_count": 44
    },
    {
        "packagetitle_name": "– All about Udyam Registration for your Business",
        "resourcedisplay_name": "DeAsra Marketing Event",
        "resourse_count": 37
    },
    {
        "packagetitle_name": "– All about Udyam Registration for your Business",
        "resourcedisplay_name": "deAsra Program",
        "resourse_count": 39
    },
    {
        "packagetitle_name": "– All about Udyam Registration for your Business",
        "resourcedisplay_name": "Group Expert Consult",
        "resourse_count": 39
    }
    ]

    const handleFilterClick = () => {
        openFilterModalisTrue()
    }

    const handleSourceModelClick = () => {
        openSourceModalisTrue()
    }

    const handleSourceModelClickEu = () => {
        openSourceModalisTrueEu()
    }

    const handleFtuPartnerModalClick = () => {
        openFtuPartnerModalisTrue()
    }

    const handleEuPartnerModalClick = () => {
        openEuPartnerModalisTrue()
    }

    const handleFtuResourceModalClick = () => {
        openFtuResourceModalisTrue()
    }

    const handleEuResourceModalClick = () => {
        openEuResourceModalisTrue()
    }

    const handleFtuProgramModalClick = () => {
        openFtuProgramModalisTrue()
    }

    const handleEuProgramModalClick = () => {
        openEuProgramModalisTrue()
    }

    const partnerList1 = []
    const programList1 = []

    partnerListdata.map((ele) => {
        if (ele.resource_name != null && ele.resource_name != "") {
            partnerList1.push(ele.resource_name)
        }
    })

    programListdata.map((ele) => {
        if (ele.resource_name != null && ele.resource_name != "") {
            programList1.push(ele.resource_name)
        }
    })

    const mergedResourceNames = [];

    // Extract resource names from the first data array
    const resourceNames1 = firstTimeProgramName.map((item) => item.resource_name).filter((name) => name !== "" && name !== null);

    // Extract resource names from the second data array
    const resourceNames2 = engagedProgramName.map((item) => item.resource_name).filter((name) => name !== "" && name !== null);


    // Merge the resource names and remove duplicates
    const mergedResourceNamesSet = new Set([...resourceNames1, ...resourceNames2]);
    mergedResourceNames.push(...mergedResourceNamesSet);

    console.log("M++", mergedResourceNames);

    const handleSourceFilterSearchClick = () => {
        const filteredData = rawSourceMediumData.filter(obj => selectedOptionsSource.some(item => item.value === obj.sourse_name));
        const filteredData1 = rawSourceMediumData.filter(obj => selectedOptionsMedium.some(item => item.value === obj.medium_name));
        const filteredData2 = rawSourceMediumData.filter(obj =>
            selectedOptionsSource.some(item => item.value === obj.sourse_name) &&
            selectedOptionsMedium.some(item => item.value === obj.medium_name)
        );

        if (selectedOptionsSource.length > 0 && selectedOptionsMedium.length > 0) {
            if (filteredData2.length > 0) {
                setFtuSourceAndMediumData(filteredData2)
            } else {
                setFtuSourceAndMediumData([{
                    sourse_name: "No Data Available",
                    medium_name: " ",
                    resourse_count: ""
                }])
            }
            openSourceModalisFalse()
        } else if (selectedOptionsSource.length > 0) {
            setFtuSourceAndMediumData(filteredData)
            console.log("test", ftuSourceAndMediumData)
            openSourceModalisFalse()
        } else if (selectedOptionsMedium.length > 0) {
            setFtuSourceAndMediumData(filteredData1)
            console.log("test1", ftuSourceAndMediumData)
            openSourceModalisFalse()
        } else {
            setFtuSourceAndMediumData(rawSourceMediumData)
            openSourceModalisFalse()
        }
    }

    const handleSourceFilterSearchClickEu = () => {
        const filteredData = rawSourceMediumDataEu.filter(obj => selectedOptionsSourceEu.some(item => item.value === obj.sourse_name));
        const filteredData1 = rawSourceMediumDataEu.filter(obj => selectedOptionsMediumEu.some(item => item.value === obj.medium_name));
        const filteredData2 = rawSourceMediumDataEu.filter(obj =>
            selectedOptionsSourceEu.some(item => item.value === obj.sourse_name) &&
            selectedOptionsMediumEu.some(item => item.value === obj.medium_name)
        );

        if (selectedOptionsSourceEu.length > 0 && selectedOptionsMediumEu.length > 0) {
            if (filteredData2.length > 0) {
                setEngagedSourceAndMediumData(filteredData2)
            } else {
                setEngagedSourceAndMediumData([{
                    sourse_name: "No Data Available",
                    medium_name: " ",
                    resourse_count: ""
                }])
            }
            openSourceModalisFalseEu()
        } else if (selectedOptionsSourceEu.length > 0) {
            setEngagedSourceAndMediumData(filteredData)
            openSourceModalisFalseEu()
        } else if (selectedOptionsMediumEu.length > 0) {
            setEngagedSourceAndMediumData(filteredData1)
            openSourceModalisFalseEu()
        } else {
            setEngagedSourceAndMediumData(rawSourceMediumDataEu)
            openSourceModalisFalseEu()
        }
    }

    const handleFtuFilterSearchClick = () => {
        const filteredData = rawFtuPartnerData.filter(obj => selectedOptionsFtuPartner.some(item => item.value === obj.resource_name));
        if (selectedOptionsFtuPartner.length > 0) {
            if (filteredData.length > 0) {
                setFirstTimePartnerData(filteredData)
            } else {
                setFirstTimePartnerData([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
            openFtuPartnerModalisFalse()
        } else {
            setFirstTimePartnerData(rawFtuPartnerData)
            openFtuPartnerModalisFalse()
        }
    }

    const handleEuFilterSearchClick = () => {
        const filteredData = rawEuPartnerData.filter(obj => selectedOptionsEuPartner.some(item => item.value === obj.resource_name));
        if (selectedOptionsEuPartner.length > 0) {
            if (filteredData.length > 0) {
                setEngagedPartner(filteredData)

            } else {
                setEngagedPartner([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
            openEuPartnerModalisFalse()
        } else {
            setEngagedPartner(rawEuPartnerData)
            openEuPartnerModalisFalse()
        }
    }

    const handleFtuResourceFilterSearchClick = () => {
        const filteredData = rawFtuResourceData.filter(obj => selectedOptionsFtuResource.some(item => item.value === obj.resourse_name));
        if (selectedOptionsFtuResource.length > 0) {
            if (filteredData.length > 0) {
                setFtuGridData(filteredData)
            } else {
                setFtuGridData([{
                    resourse_name: "No Data Available",
                    resourse_count: ''
                }])
            }
            openFtuResourceModalisFalse()
        } else {
            setFtuGridData(rawFtuResourceData)
            openFtuResourceModalisFalse()
        }
    }

    const handleEuResourceFilterSearchClick = () => {
        const filteredData = rawEuResourceData.filter(obj => selectedOptionsEuResource.some(item => item.value === obj.resourse_name));
        if (selectedOptionsEuResource.length > 0) {
            if (filteredData.length > 0) {
                setEuGridData(filteredData)
            } else {
                setEuGridData([{
                    resourse_name: "No Data Available",
                    resourse_count: ''
                }])
            }
            openEuResourceModalisFalse()
        } else {
            setEuGridData(rawEuResourceData)
            openEuResourceModalisFalse()
        }
    }

    const handleFtuProgramFilterSearchClick = () => {
        const filteredData = rawFtuProgramData.filter(obj => selectedOptionsFtuProgram.some(item => item.value === obj.resource_name));
        if (selectedOptionsFtuProgram.length > 0) {
            if (filteredData.length > 0) {
                setFirstTimeProgramData(filteredData)
            } else {
                setFirstTimeProgramData([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
            openFtuProgramModalisFalse()
        } else {
            setFirstTimeProgramData(rawFtuProgramData)
            openFtuProgramModalisFalse()
        }
        console.log("Filtered Data", firstTimeProgramData)
    }

    const handleEuProgramFilterSearchClick = () => {
        const filteredData = rawEuProgramData.filter(obj => selectedOptionsEuProgram.some(item => item.value === obj.resource_name));
        if (selectedOptionsEuProgram.length > 0) {
            if (filteredData.length > 0) {
                setEngagedUserProgramData(filteredData)
            } else {
                setEngagedUserProgramData([{
                    resource_name: "No Data Available",
                    resource_count: ''
                }])
            }
            openEuProgramModalisFalse()
        } else {
            setEngagedUserProgramData(rawEuProgramData)
            openEuProgramModalisFalse()
        }
    }

    const [isClearClicked, setIsClearClicked] = useState(false);

    const handleClearClick = () => {
        if (!isProgramManagerDashboard) {
            setSelectedOptions([])
            setEntryPointList([])
            setSelectedsEntryPoint([])

            setFtuGridData([])
            setEuGridData([])
            setFirstTimePartnerData([])
            setEngagedPartner([])
            setFirstTimeAnnualTurnoverData([])
            setEngagedAnnualTurnoverData([])
            setFtuSourceAndMediumData([])
            setEngagedSourceAndMediumData([])
            setFirstTimeChartData([])
            setEngagedChartData([])
            setResourceAwailedChartData([])
            setFirstTimeProgramData([])
            setEngagedUserProgramData([])
            setPartnerTableData([])
            setProgramTableData([])
            setFirstTimePartnerResourceData([])
            setEngagedPartnerResourceData([])
            setFirstTimeProgramResourceData([])
            setEngagedProgramResourceData([])

            setSelectedOptionsProgram([])
            setfromDate()
            settoDate()
            setSelectedOptionsSource([])
            setSelectedOptionsMedium([])
            setSelectedOptionsSourceEu([])
            setSelectedOptionsMediumEu([])
            setSelectedOptionsEuPartner([])
            setSelectedOptionsFtuPartner([])
            setSelectedOptionsEuResource([])
            setSelectedOptionsFtuResource([])
            setSelectedOptionsEuProgram([])
            setSelectedOptionsFtuProgram([])
            setSelectedOptionsMergedPartner([])
            setSelectedOptionsMergedProgram([])
            setSelectedOptionsMergedResource([])
            setSelectedOptionsMergedPartnerResource([])
            setSelectedOptionsMergedPartnerResourceEu([])
            setSelectedOptionsMergedProgramResource([])
            setSelectedOptionsMergedProgramResourceEu([])
            setSelectedOptionsMergedSourceMedium([])
            setSelectedOptionsMergedSourceMediumEu([])
            setIsProgramData(false);
            setIsClearClicked(true);
            localStorage.removeItem("fromDate")
            localStorage.removeItem("toDate")

            //dreambig
            setSelectedOptionsTopResources([]);
        } else {
            setfromDate()
            settoDate()
            setEntryPointList([])
            setSelectedsEntryPoint([])
            setSelectedProgramManager([])
            setPartnerDataProgramManager([])
            setProgramDataManager([])
            localStorage.removeItem("fromDate")
            localStorage.removeItem("toDate")
            // if(selectedProgramManager){
            //     getProgramManagerData(selectedProgramManager)
            // }

        }
        if (clearRef.current) {
            clearRef.current.handleClearVehicleDeviceFilter();
          }
    }

    useEffect(() => {
        if (isClearClicked) {
            getTableData(); // Call getTableData when isClearClicked is true
            setIsClearClicked(false); // Reset the clear flag to false
        }
    }, [isClearClicked]);

    const handleFilterByModalClearClick = () => {
        setSelectedOptions([])
        setSelectedOptionsProgram([])
        setfromDate()
        settoDate()

    }

    const handleEuSourceFilterClearClick = () => {
        setSelectedOptionsSourceEu([])
        setSelectedOptionsMediumEu([])
    }

    const handleFtuSourceFilterClearClick = () => {
        setSelectedOptionsSource([])
        setSelectedOptionsMedium([])
    }

    const handleEuPartnerFilterClearClick = () => {
        setSelectedOptionsEuPartner([])
    }

    const handleFtuPartnerFilterClearClick = () => {
        setSelectedOptionsFtuPartner([])
    }

    const handleEuResourceFilterClearClick = () => {
        setSelectedOptionsEuResource([])
    }

    const handleFtuResourceFilterClearClick = () => {
        setSelectedOptionsFtuResource([])
    }

    const handleEuProgramFilterClearClick = () => {
        setSelectedOptionsEuProgram([])
    }

    const handleFtuProgramFilterClearClick = () => {
        setSelectedOptionsFtuProgram([])
    }

    useEffect(() => {
        const handleBeforeUnload = () => {
            localStorage.removeItem('fromDate');
            localStorage.removeItem('toDate')
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const handleSearchVehicle=()=>{
        console.log("search clicked");
    }

    const handleSearchClick = async () => {
        if (!fromDate && !toDate) {
            localStorage.removeItem("fromDate")
            localStorage.removeItem("toDate")
        }
        fromDate && localStorage.setItem("fromDate", fromDate.toLocaleDateString("en-GB"))
        toDate && localStorage.setItem("toDate", toDate.toLocaleDateString("en-GB"))
        getFTCDataByPM(selectedEnties);
        if(selectedResourceName && selectedResourceName.length > 0){
            getUserCountByResource(selectedResourceName)
        }
        // if (searchRef?.current) {
        //     searchRef?.current?.getFTCVehicleData();
        //   }
        // if (searchRef?.current) {
        //     searchRef?.current.handleSearchClick();
        //   }
        

        if (!isProgramManagerDashboard) {

            selectedOptions.map((ele) => {
                partnerListUpdated.push(ele.value)
            })
            partnerListUpdated.map((ele) => {
                arr.push(
                    {
                        resource_name: ele,
                        First_Time_Usres: 0,
                        Engaged_Users: 0
                    }
                )
            })

            console.log("Np", arr)

            selectedOptionsProgram.map((element) => {
                programListUpdated.push(element.value)
            })

            setIsPartnerData(selectedOptions.length !== 0, () => {
                console.log('isPartnerData:', isPartnerData);
            });
            setIsProgramData(selectedOptionsProgram.length !== 0, () => {
                console.log('isProgramData:', isProgramData);
            });

            openFilterModalisFalse()
            setFtuGridData([])
            setEuGridData([])
            setFirstTimePartnerData([])
            setEngagedPartner([])
            setFirstTimeAnnualTurnoverData([])
            setEngagedAnnualTurnoverData([])
            setFtuSourceAndMediumData([])
            setEngagedSourceAndMediumData([])
            setFirstTimeChartData([])
            setEngagedChartData([])
            setResourceAwailedChartData([])
            setFirstTimeProgramData([])
            setEngagedUserProgramData([])
            setPartnerTableData([])
            setProgramTableData([])
            setFirstTimePartnerResourceData([])
            setEngagedPartnerResourceData([])
            setFirstTimeProgramResourceData([])
            setEngagedProgramResourceData([])
            getTableData()
        } else {
            openFilterModalisFalse()
            if (selectedProgramManager) {
                getProgramManagerData(selectedProgramManager)
                getProgramDataforManager(selectedProgramManager)
            }
        }
    }

    useEffect(() => {
        getTableData()
    }, [])

    console.log(isProgramData, ">>>>>>isProgramData");
    console.log(openAllFilterSearchModal, ">>>>>openAllFilterSearchModal");
    console.log(selectedOppTitle, ">>>>selectedOppTitle")
    console.log(selectedOppTitleVal, ">>>>selectedOppTitleVal");
    console.log(selectedOptionsVehicleType, ">>>>selectedOptionsVehicleType");
    console.log(allVehicleTypeOptions, ">>>>allVehicleTypeOptions");
    console.log(vehicleOptions, ">>>>vehicleOptions");

    return (
        <div>
            {/* <div className="row mt-3 mb-4"> */}
            <div className={`${!isPartnerData && !isProgramData ? "row mt-3 mb-4" : "row mt-2"}`}>

                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                            <div style={{
                                backgroundColor: '#78417C',
                                color: "#fff"
                            }} className="esp-dashboard-card conv-text-center"
                                title='Dream Big FTU.'
                            >
                                <label className="esp-box-header-title">DreamBig FTU </label>
                                <h5 className="esp-count-text1">{TotalFirstTimeUserCount || 0}</h5>
                                <div style={{ clear: "both" }}></div>
                            </div>
                            :
                            ""
                    }
                </div>

                <div className="col-2">
                    {
                        !isPartnerData && !isProgramData ?
                            <div style={{
                                backgroundColor: '#78417C',
                                color: "#fff"
                            }} className="esp-dashboard-card conv-text-center"
                                title='Dream Big EU that become engaged with the customers that were already FTU before 4th April 2025.'
                            >
                                <label className="esp-box-header-title">DreamBig EU</label>
                                <h5 className="esp-count-text1" style={{
                                    color: "#fff !important"
                                }}>{TotalEngagedUserCount || 0}</h5>
                                <div style={{ clear: "both" }}></div>
                            </div>
                            :
                            ""
                    }
                </div>

                <div className="col-8" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end" }}>
                    <Button className="esp-inline-button ml-2" style={{
                        marginBottom: "15px"
                    }} onClick={handleFilterClick}>
                        <img
                            alt=""
                            src={ic_filter}
                            height={"15px"}
                            width={"15px"}
                            className="conv-mr10"
                        />
                        Filter By</Button>
                    <Button className="esp-inline-button ml-2" style={{
                        marginBottom: "15px"
                    }} onClick={handleClearClick}>
                        Clear filter</Button>
                </div>


            </div>

            <a onClick={goToProgramManagerDashboard} className="con-cursor-pointer"
                style={{
                    color: "#78417C",
                    position: 'absolute',
                    right: 24,
                    zIndex: 1
                }}>
                {isProgramManagerDashboard ?
                    <span className='text-hover'>Go Back to Reports</span>
                    :
                    <span className='text-hover'>Program Manager Dashboard</span>
                }
            </a>

            <Modal isOpen={newModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter Date Wise</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFilterModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-6 spled-container conv-zindex">
                                <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={fromDate}
                                        onChange={(date) => ondatechange("fromDate", date)}
                                        placeholderText="From Date"
                                        minDate={new Date("01-01-2013")}
                                    />
                                </div>
                            </div>

                            <div className="col-6 spled-container conv-zindex">
                                <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={toDate}
                                        onChange={(date) => ondatechange("toDate", date)}
                                        placeholderText="To Date"
                                        maxDate={new Date()}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className="offset-1 col-5">
                                <Button className="esp-inline-button" onClick={handleSearchClick}>Search</Button>
                            </div>
                            <div className="col-5">
                                <Button className="esp-inline-button" onClick={handleFilterByModalClearClick}>Clear</Button>
                            </div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>


            {/* Source and Medium filter Model */}

            <Modal isOpen={sourceModel}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openSourceModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={sourceListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Source"
                                        value={selectedOptionsSource}
                                        onChange={handleSelectSource}
                                    />
                                </div>
                            </div>
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={mediumListData.map((program) => ({
                                            label: program,
                                            value: program,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select medium"
                                        value={selectedOptionsMedium}
                                        onChange={handleSelectMedium}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className="col-5">
                                <Button className="esp-inline-button" onClick={handleSourceFilterSearchClick}>Search</Button>
                            </div>
                            <div className="offset-1 col-5">
                                <Button className="esp-inline-button" onClick={handleFtuSourceFilterClearClick}>Clear</Button>
                            </div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Engaged user Source Medium Filter Modal */}

            <Modal isOpen={sourceModelEu}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openSourceModalisFalseEu}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={sourceListDataEu.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Source"
                                        value={selectedOptionsSourceEu}
                                        onChange={handleSelectSourceEu}
                                    />
                                </div>
                            </div>
                            <div className="col-6 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={mediumListDataEu.map((program) => ({
                                            label: program,
                                            value: program,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select medium"
                                        value={selectedOptionsMediumEu}
                                        onChange={handleSelectMediumEu}
                                    />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className="offset-1 col-5">
                                <Button className="esp-inline-button" onClick={handleEuSourceFilterClearClick}>Clear</Button>
                            </div>
                            <div className="col-5">
                                <Button className="esp-inline-button" onClick={handleSourceFilterSearchClickEu}>Search</Button>
                            </div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Ftu Partner Filter Modal */}

            <Modal isOpen={ftuPartnerModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFtuPartnerModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={ftuPartnerListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Partner"
                                        value={selectedOptionsFtuPartner}
                                        onChange={handleFtuPartnerSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleFtuFilterSearchClick}>Search</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleFtuPartnerFilterClearClick}>Clear</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Eu Partner Filter Modal */}

            <Modal isOpen={euPartnerModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openEuPartnerModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={EuPartnerListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Partner"
                                        value={selectedOptionsEuPartner}
                                        onChange={handleEuPartnerSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleEuPartnerFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleEuFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Ftu Resource Filter Modal */}

            <Modal isOpen={ftuResourceModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFtuResourceModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-12 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={ftuResourceListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Resource"
                                        value={selectedOptionsFtuResource}
                                        onChange={handleFtuResourceSelect}
                                    />
                                </div>
                            </div>
                            {/* <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleFtuResourceFilterClearClick}>Clear</Button>
                                </div>
                            </div> */}
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className='offset-1 col-4'>
                                <Button className="esp-inline-button" onClick={handleFtuResourceFilterClearClick}>Clear</Button>
                            </div>
                            <div className="offset-1 col-4">
                                <Button className="esp-inline-button" onClick={handleFtuResourceFilterSearchClick}>Search</Button>
                            </div>
                            {/* <div className='col-4'></div> */}
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Eu Resource Filter Modal */}

            <Modal isOpen={euResourceModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openEuResourceModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={EuResourceListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Resource"
                                        value={selectedOptionsEuResource}
                                        onChange={handleEuResourceSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleEuResourceFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleEuResourceFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Ftu Program Filter Modal */}

            <Modal isOpen={ftuProgramModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openFtuProgramModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={ftuProgramListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Program"
                                        value={selectedOptionsFtuProgram}
                                        onChange={handleFtuProgramSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleFtuProgramFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleFtuProgramFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {/* Eu Program Filter Modal */}

            <Modal isOpen={euProgramModal}>
                <ModalContent className="EngagedDashboard-filter-modal">
                    <div className="modal-header">
                        <span className="modal-title">Filter</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openEuProgramModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        <br />
                        <div className="row">
                            <div className="col-8 spled-container">
                                <div className="width-100">
                                    <ReactMultiSelectCheckboxes
                                        options={EuProgramListData.map((partner) => ({
                                            label: partner,
                                            value: partner,
                                        }))}
                                        // placeholder="Select partners"
                                        placeholderButtonLabel="Select Program"
                                        value={selectedOptionsEuProgram}
                                        onChange={handleEuProgramSelect}
                                    />
                                </div>
                            </div>
                            <div className="col-4 spled-container">
                                <div className="width-100">
                                    <Button className="esp-inline-button" onClick={handleEuProgramFilterClearClick}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row d-flex justify-content-center align-items-center'>
                            <div className='col-4'></div>
                            <div className="col-4">
                                <Button className="esp-inline-button" onClick={handleEuProgramFilterSearchClick}>Search</Button>
                            </div>
                            <div className='col-4'></div>
                            {/* <div className="col-4"></div> */}
                        </div>

                    </div>
                </ModalContent>
            </Modal>

            {isProgramData && isPartnerData ?
                <div>
                    <div className="row">
                        <div className='col-12'>
                            <DreamBigPartnerDataTable
                                data={partnerTableData} />
                        </div>
                        {programTableData.map((item) => {
                            let partnerNames = item.partnerData.reduce((uniqueNames, row) => {
                                if (row.sEntryPoint && !uniqueNames.includes(row.sEntryPoint)) {
                                    uniqueNames.push(row.sEntryPoint);
                                }
                                return uniqueNames;
                            }, [])

                            return (
                                <div className='col-6 mt-3'>
                                    <DreamBigDynamicProgramTable
                                        key={item.sPackageTitle}
                                        programName={item.sPackageTitle}
                                        partnerData={item.partnerData}
                                        partnerNames={partnerNames}
                                    />
                                </div>
                            )
                        })}

                    </div>

                </div>
                :
                isProgramData ?
                    <div className="row">
                        {
                            programTableData.length > 0 && programTableData[0] != "" ?
                                programTableData.map((item) => {
                                    let partnerNames = item.partnerData.reduce((uniqueNames, row) => {
                                        if (row.sEntryPoint && !uniqueNames.includes(row.sEntryPoint)) {
                                            uniqueNames.push(row.sEntryPoint);
                                        }
                                        return uniqueNames;
                                    }, [])

                                    return (
                                        <div className='col-6 mt-3'>
                                            <DreamBigDynamicProgramTable
                                                key={item.sPackageTitle}
                                                programName={item.sPackageTitle}
                                                partnerData={item.partnerData}
                                                partnerNames={partnerNames}
                                            />
                                        </div>
                                    )
                                })
                                :
                                programTableData.length > 0 && programTableData[0] === "" ?
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "65vh", width: "100%" }}>
                                        <div style={{ maxWidth: "500px", textAlign: "center" }}>
                                            No Data Found for Selected Programs
                                        </div>
                                    </div>
                                    :
                                    <Spinner className="center-screen" />
                        }
                    </div>
                    :
                    isPartnerData ?
                        <div className='row'>
                            <div className='col-12'>
                                <DreamBigPartnerDataTable
                                    data={partnerTableData} />
                            </div>

                        </div>
                        :
                        isProgramManagerDashboard ?
                        <div className="row mt-1, ml-1 mr-1">
                                <div className="col-12">
                                    <DreamBigProgramManagerHome
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        setPartnerDataProgramManager={setPartnerDataProgramManager}
                                        // onProgramManagerChange={onProgramManagerChange}
                                        getResourceDataForSelectedPartner={getResourceDataForSelectedPartner}
                                        getProgramManagerData={getProgramManagerData}
                                        resourceDataSelectedPartner={resourceDataSelectedPartner}
                                        setResourceDataSelectedPartner={setResourceDataSelectedPartner}
                                        partnerDataProgramManager={partnerDataProgramManager}
                                        selectedProgramManager={selectedProgramManager}
                                        setSelectedProgramManager={setSelectedProgramManager}
                                        setSelectedPartnerName={setSelectedPartnerName}
                                        selectedPartnerName={selectedPartnerName}
                                        // selectedProgramManager={selectedProgramManager}

                                        getProgramDataforManager={getProgramDataforManager}
                                        programDataManager={programDataManager}
                                        setProgramDataManager={setProgramDataManager}
                                        getPartnerDataForSelectedProgram={getPartnerDataForSelectedProgram}
                                        partnerDataForSelectedProgram={partnerDataForSelectedProgram}
                                        setSelectedProgramName={setSelectedProgramName}
                                        selectedProgramName={selectedProgramName}
                                        getEntryPoints={getEntryPoints}
                                        entryPointList={entryPointList} 
                                        selectedsEntryPoint={selectedsEntryPoint}
                                        setSelectedsEntryPoint={setSelectedsEntryPoint}
                                        getFTCDataByPM={getFTCDataByPM}
                                        pmData={pmData}
                                        isClearClicked={isClearClicked}
                                        clearRef={clearRef}
                                        searchRef={searchRef}
                                    />
                                </div>
                            </div>
                            :
                            <div>
                                <div className="row mt-3 mb-3">
                                    <div className="col-12">
                                        {/* <MergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} /> */}
                                        <DreamBigMergedPartnerResourceTable
                                            firstTimeData={firstTimePartnerResourceData}
                                            engagedData={engagedPartnerResourceData}
                                            selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource}
                                            setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource}
                                            selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu}
                                            setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} isFirstUsertableLoading={isFirstUsertableLoading} />
                                    </div>
                                </div>

                                {/* table-2 before 4th april */}
                                <div className="row mt-3 mb-3">
                                    <div className="col-12">
                                        <TotalResourceConsumedByUserTableBefore4thApril
                                            totalResourceConsumedByUserBefore4thApril={totalResourceConsumedByUserBefore4thApril}
                                        />
                                    </div>
                                </div>

                                {/* table-2 after 4th april */}
                                <div className="row mt-3 mb-3">
                                    <div className="col-12">
                                        <TotalResourceConsumedByUserTable
                                            totalResourceConsumedByUser={totalResourceConsumedByUser}
                                        />
                                    </div>
                                </div>

                                {/* table-3 */}
                                <div className="row mt-3 mb-3">
                                    <div className="col-12">
                                        {/* <MergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} /> */}
                                        <TopResources
                                            topResources={topResources}
                                            setSelectedOptionsTopResources={setSelectedOptionsTopResources}
                                            selectedOptionsTopResources={selectedOptionsTopResources}
                                        />
                                    </div>
                                </div>


                                {/* old 1 */}
                                {/* <div className="row mt-3 mb-3">
                                    <div className="col-12">
                                       // <MergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} />
                                        <DreamBigMergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} isFirstUsertableLoading={isFirstUsertableLoading} />
                                    </div>
                                </div> */}

                                {/* old 2, now table-4 */}
                                <div className="row mb-3">
                                    <div className="col-12">
                                        {/* <MergedTurnoverTable firstTimeData={firstTimeAnnualTurnoverData} engagedData={engagedAnnualTurnoverData}/> */}
                                        <DreamBigMergedTurnoverTable firstTimeData={firstTimeAnnualTurnoverData} engagedData={engagedAnnualTurnoverData} />
                                    </div>
                                </div>

                                {/* table-5 */}
                                <div className="row mt-3 mb-3">
                                    <div className={`col-12  ${isVehicleDeviceLoading && "set-opacity"}`}>
                                        {isVehicleDeviceLoading && <Spinner className="center" />}
                                        <FTUBasedOnVehicleQuestion
                                            ftuVehicleQuestionCount={ftuVehicleQuestionCount}
                                            ftuDeviceCount={ftuDeviceCount}
                                            vehicleDeviceCombination={vehicleDeviceCombination}
                                            vehicleOptions={vehicleOptions}
                                            deviceOptions={deviceOptions}
                                            vehicleDeviceCombinationFilterData={vehicleDeviceCombinationFilterData}
                                            isFilterActive={isFilterActive}

                                            // below not used
                                            firstTimeData={firstTimePartnerResourceData}
                                            engagedData={engagedPartnerResourceData}
                                            selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource}
                                            setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource}
                                            selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu}
                                            setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu}
                                            isFirstUsertableLoading={isFirstUsertableLoading}

                                            handleVehicleDeviceFilterOpen={handleVehicleDeviceFilterOpen}
                                        />
                                    </div>
                                </div>

                                {/* old-1 jaisa, table-6 */}
                                <div className="row mt-3 mb-3">
                                    <div className="col-12">
                                        {/* <MergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} /> */}
                                        <SourcesBasedOnEntryPointTable
                                            topSourcesBasedOnEntryPoint={topSourcesBasedOnEntryPoint}
                                            setSelectedOptionsTopEntryPoint={setSelectedOptionsTopEntryPoint}
                                            selectedOptionsTopEntryPoint={selectedOptionsTopEntryPoint}
                                        />
                                    </div>
                                </div>

                                {/* All filter table */}
                                <div className={`row mt-3 mb-3`}>
                                    <div className={`col-12  ${isLoading && "set-opacity"}`}>
                                        {isLoading && <Spinner className="center" />}
                                        {/* <MergedPartnerResourceTable firstTimeData={firstTimePartnerResourceData} engagedData={engagedPartnerResourceData} selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource} setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource} selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu} setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu} /> */}
                                        <DreamBigAllFilterTable
                                            topSourcesBasedOnEntryPoint={topSourcesBasedOnEntryPoint}
                                            setSelectedOptionsTopEntryPoint={setSelectedOptionsTopEntryPoint}
                                            selectedOptionsTopEntryPoint={selectedOptionsTopEntryPoint}

                                            firstAndEngagedCombineData={firstAndEngagedCombineData}
                                            handleOpen={handleOpen}
                                        />


                                    </div>
                                </div>
                            </div>
            }

{isProgramManagerDashboard ?
 <div className="row mt-1, ml-1 mr-1">
                                <div className={`col-12  ${isResourceTableLoading && "set-opacity"}`}>
                                    <DreamBigLandingPage
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        setPartnerDataProgramManager={setPartnerDataProgramManager}
                                        // onProgramManagerChange={onProgramManagerChange}
                                        getResourceDataForSelectedPartner={getResourceDataForSelectedPartner}
                                        getProgramManagerData={getProgramManagerData}
                                        resourceDataSelectedPartner={resourceDataSelectedPartner}
                                        setResourceDataSelectedPartner={setResourceDataSelectedPartner}
                                        partnerDataProgramManager={partnerDataProgramManager}
                                        selectedResourceName={selectedResourceName}
                                        setSelectedResourceName={setSelectedResourceName}
                                        setSelectedPartnerName={setSelectedPartnerName}
                                        selectedPartnerName={selectedPartnerName}
                                        // selectedProgramManager={selectedProgramManager}

                                        getProgramDataforManager={getProgramDataforManager}
                                        programDataManager={programDataManager}
                                        setProgramDataManager={setProgramDataManager}
                                        getPartnerDataForSelectedProgram={getPartnerDataForSelectedProgram}
                                        partnerDataForSelectedProgram={partnerDataForSelectedProgram}
                                        setSelectedProgramName={setSelectedProgramName}
                                        selectedProgramName={selectedProgramName}
                                        getEntryPoints={getEntryPoints}
                                        entryPointList={entryPointList} 
                                        selectedsEntryPoint={selectedsEntryPoint}
                                        setSelectedsEntryPoint={setSelectedsEntryPoint}
                                        getUserCountByResource={getUserCountByResource}
                                        landingPageData={landingPageData}
                                        isClearClicked={isClearClicked}
                                        isResourceTableLoading={isResourceTableLoading}
                                        clearRef={clearRef}
                                        searchRef={searchRef}

                                    />
                                </div>
                            </div>
                            :
                            ""
                    }

            {/* All filter modal */}
            <Modal isOpen={openAllFilterModel}>
                <ModalContent className="dreambig-all-filter-modal">
                    <div className="modal-header" style={{
                        // backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">All Filters</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            // onClick={()=>handleCloseSmsModel(false)}
                            onClick={handleClose}
                        />
                    </div>

                    <div className="modal-body">
                        {/* <div className='row pb-2' style={{ paddingLeft: "30px", boxShadow: "0 5px 5px -2px rgba(0, 0, 0, 0.5)", backgroundColor: "" }}>
                            <div className='col-4'>
                                <Button style={{
                                    margin: 0,
                                    height: '37px'
                                }}
                                    // onClick={handleSendMessage}
                                    // disabled={!selectedOppTitleForSendSms}
                                    className="con-btn-filled">
                                    Send Message
                                </Button>
                            </div>
                        </div> */}
                        <div
                        // className={`${loadingInModal && "set-opacity"}`}
                        >
                            {/* {loadingInModal && <Spinner className="center" />} */}
                            <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "" }}>
                                {
                                    <div className="" style={{
                                        height: "300px",
                                        backgroundColor: "",
                                    }}>
                                        {/* 0 */}
                                        <div className="row mb-3" style={{ padding: "0px 30px", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "7" }}>
                                                <MultiSelectAll
                                                    toggleAll={toggleAllOppTitle}
                                                    toggleSelection={onOppTitleChange}
                                                    checkboxItemsList={oppTitleNameList}
                                                    selectedOptions={selectedOppTitle}
                                                    placeholderButtonLabel="Select Filter By"
                                                />
                                            </div>
                                        </div>

                                        {/* 1 */}
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "6" }}>
                                                <Select
                                                    options={allResourceIdOptions}
                                                    onChange={onResourceIdChange}
                                                    value={selectedResourceId}
                                                    placeholder="Select Resource Id"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sResourceID") ? false : true}
                                                />
                                            </div>

                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "6" }}>
                                                <Select
                                                    options={allResourceTypeOptions}
                                                    onChange={onResourceTypeChange}
                                                    value={selectedResourceType}
                                                    placeholder="Select Resource Type"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sResourceType") ? false : true}
                                                />
                                            </div>

                                        </div>

                                        {/* 2 */}
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "5" }}>
                                                <Select
                                                    options={allResourceDisplayNameOptions}
                                                    onChange={onResourceDisplayNameChange}
                                                    value={selectedResourceDisplayName}
                                                    placeholder="Select Resource Display name"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sResourceDisplayName") ? false : true}
                                                />
                                            </div>

                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "5" }}>
                                                <Select
                                                    options={allSourceOptions}
                                                    onChange={onSourceChange}
                                                    value={selectedSource}
                                                    placeholder="Select Source"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sSource") ? false : true}
                                                />
                                            </div>

                                        </div>

                                        {/* 3 */}
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "3" }}>
                                                <Select
                                                    options={allBusinessTurnOverOptions}
                                                    onChange={onBusinessTurnOverChange}
                                                    value={selectedBusinessTurnOver}
                                                    placeholder="Select Business Turnover"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sBusinessTurnover") ? false : true}
                                                />
                                            </div>

                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "3" }}>
                                                <Select
                                                    options={allProgrammeManagerOptions}
                                                    onChange={onProgrammeManagerChange}
                                                    value={selectedProgrammeManager}
                                                    placeholder="Select Programme Manager"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sProgramManager") ? false : true}
                                                />
                                            </div>

                                        </div>

                                        {/* 4 */}
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "2" }}>
                                                <Select
                                                    options={allVehicleTypeOptions}
                                                    onChange={onVehicleTypeChange}
                                                    value={selectedVehicleType}
                                                    placeholder="Select Vehicle Type"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("vehicle_type") ? false : true}
                                                />
                                            </div>

                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "2" }}>
                                                <Select
                                                    options={allDeviceTypeOptions}
                                                    onChange={onDeviceTypeChange}
                                                    value={selectedDeviceType}
                                                    placeholder="Select Device Type"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("device_type") ? false : true}
                                                />
                                            </div>
                                        </div>

                                        {/* 5 */}
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            {/* <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "4" }}>
                                                <Select
                                                    options={allMediumOptions}
                                                    onChange={onMediumChange}
                                                    value={selectedMedium}
                                                    placeholder="Select Medium"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sMedium") ? false : true}
                                                />
                                            </div> */}

                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "4" }}>
                                                <Select
                                                    options={allEntryPointOptions}
                                                    onChange={onEntryPointChange}
                                                    value={selectedEntryPoint}
                                                    placeholder="Select Entry Point"
                                                    isClearable
                                                    isDisabled={selectedOppTitleVal.includes("sEntryPoint") ? false : true}
                                                />
                                            </div>

                                        </div>



                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-12 mt-5 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>
                                                <Button onClick={handleClearAll}>Clear All</Button>

                                                <Button onClick={handleAllFilterSearch}>Search</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </Modal>

            {/* vehicle and device type filter modal */}
            <Modal isOpen={isVehicleDeviceTypeFilterOpen}>
                <ModalContent className="dreambig-device-vehicle-filter-modal">
                    <div className="modal-header" style={{
                        // backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">All Filters</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            // onClick={()=>handleCloseSmsModel(false)}
                            onClick={() => setIsVehicleDeviceTypeFilterOpen(false)}
                        />
                    </div>

                    <div className="modal-body">
                        <div>
                            {/* {loadingInModal && <Spinner className="center" />} */}
                            <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "" }}>
                                {
                                    <div className="" style={{
                                        height: "300px",
                                        backgroundColor: "",
                                    }}>
                                        {/* 1 */}
                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "6" }}>
                                                {/* <Select
                                                    options={vehicleOptions}
                                                    onChange={onVehicleChange}
                                                    value={selectedVehicle}
                                                    placeholder="Select Vehicle Type"
                                                    isClearable
                                                // isDisabled={selectedOppTitleVal.includes("sResourceID") ? false : true}
                                                /> */}

                                                <ReactMultiSelectCheckboxes
                                                    options={vehicleOptions}
                                                    placeholderButtonLabel="Select Vehicle Type"
                                                    value={selectedOptionsVehicleType}
                                                    onChange={handleMultipleVehicleSelect}
                                                />
                                            </div>

                                            <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "6" }}>
                                                {/* <Select
                                                    options={deviceOptions}
                                                    onChange={onDeviceChange}
                                                    value={selectedDevice}
                                                    placeholder="Select Device Type"
                                                    isClearable
                                                // isDisabled={selectedOppTitleVal.includes("sResourceType") ? false : true}
                                                /> */}

                                                <ReactMultiSelectCheckboxes
                                                    options={deviceOptions}
                                                    placeholderButtonLabel="Select Device Type"
                                                    value={selectedOptionsDeviceType}
                                                    onChange={handleMultipleDeviceSelect}
                                                />
                                            </div>

                                        </div>

                                        <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                                            <div className="col-12 mt-5 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>
                                                <Button onClick={handleClearVehicleDeviceFilter}>Clear All</Button>

                                                <Button onClick={handleVehicleDeviceCombinationSearch}>Search</Button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </Modal>
        </div>
    )
}

export default DreamBigNewAndEngagedUserHome
